import { usePage } from "@tecnobit-srl/router";
import { createState } from "@tecnobit-srl/state";
import { createInstance } from "i18next";
import { merge } from "lodash-es";
import { useEffect, useMemo } from "react";
import { initReactI18next, useTranslation } from "react-i18next";
import { useLogger } from "@tecnobit-srl/dev-logger";
import { jsx } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esmMin = (fn, res, err) => () => {
	if (err) throw err[0];
	try {
		return fn && (res = fn(fn = 0)), res;
	} catch (e) {
		throw err = [e], e;
	}
};
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod, mod.exports), cb = null), mod.exports);
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __hasOwnProp.call(mod, "module.exports") ? mod["module.exports"] : __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var core_default$11 = {
	download: { "wait_download": "<0>Stahování začne během několika vteřin. Jestliže stahování nezačne automaticky,<1>klikněte zde</1>a stahování začne.</0>" },
	form: {
		"required": "Toto pole je povinné",
		"minLength": "Napište nejméně {{num}} znaků",
		"maxLength": "Maximální počet povolených znaků {{num}}",
		"pattern": "Tato hodnota není platná",
		"min": "Minimální počet znaků {{num}}",
		"max": "Maximální počet znaků {{num}}",
		"add_file": "Přidat soubor",
		"too_many_files": "Příliš mnoho souborů",
		"too_few_files": "Příliš málo aouborů",
		"file_too_big": "Vybraný soubor je příliš velký",
		"invalid_file": "Vybraný soubor není platný",
		"max_files": "Maximální počet souborů",
		"min_files": "Minimální počet souborů",
		"types_allowed": "Povolené soubory",
		"max_weight": "Maximální velikost souborů",
		"submit_file_is_uploading": "Musíte počkat pro odeslání, abyste mohl skončit před podáním formuláře",
		"upload_error": "Došlo k chybě při odesílání vašeho souboru. Prosím, zkuste znovu.",
		"submit_validation_error": "Došlo k chybě během podání vašeho souboru. Prosím, zkontrolujte data a zkuste znovu.",
		"submit_error": "Došlo k chybě během podání vašeho souboru.. Jestliže problém trvá, kontaktujte nás.",
		"privacy": "Četl jsem a souhlasím se <1><0>Zásadami soukromí</0></1>",
		"terms": "Četl jsem a souhlasím se <1><0>smluvními podmínkami</1>.",
		"login_prefill": "<0>Přihlaste se</0> pro automatické doplnění vašich informací do formuláře.",
		"signup_suggestion": "<0>Přihlaste se nyní</0> pro doplnění vašich dat do formulářů!",
		"captcha_not_resolved": "Musíte potvrdit, že jste člověk před odesláním formuláře.",
		"captcha_not_ready": "Ověření captcha není připraveno. Znovu načtěte stránku a zkuste to znovu.",
		"invalid_phone_prefix": "Předčíslí není platné",
		"invalid_email": "Neplatná email adresa",
		"select": {
			"create": "{userInput}",
			"loading": "Nahrávání...",
			"no_options": "Žádné možnosti"
		},
		"invalid_phone": "Telefonní číslo je neplatné",
		"doesnt_match": "Vložené hodnoty neodpovídají",
		"meeting": {
			"duration": "Délka: {{duration}}",
			"duration_label": "Délka",
			"duration_minutes": "{{minutes}} min",
			"loading": "Načítání dostupnosti…",
			"empty": "Momentálně žádná dostupnost.",
			"no_slots": "Pro vybrané datum nejsou k dispozici žádné časy.",
			"back": "Zpět na kalendář",
			"change": "Změnit datum/čas",
			"timezone": "Časové pásmo: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Pondělí",
					"short": "Po"
				},
				"tuesday": {
					"long": "Úterý",
					"short": "Út"
				},
				"wednesday": {
					"long": "Středa",
					"short": "St"
				},
				"thursday": {
					"long": "Čtvrtek",
					"short": "Čt"
				},
				"friday": {
					"long": "Pátek",
					"short": "Pá"
				},
				"saturday": {
					"long": "Sobota",
					"short": "So"
				},
				"sunday": {
					"long": "Neděle",
					"short": "Ne"
				}
			}
		},
		"slots": {
			"add": "Přidat dostupnost",
			"remove": "Odebrat",
			"timezone": "Časové pásmo: {{timezone}}",
			"min": "Uveďte alespoň {{num}} termínů.",
			"max": "Můžete uvést nejvýše {{num}} termínů.",
			"item": "Dostupnost {{number}}"
		}
	},
	pricing: {
		"recommended": "Doporučeno",
		"discounted_to": "Podpora končí {{date}}",
		"per_month": "měsíčně",
		"per_year": "ročně",
		"free": "ZDARMA",
		"badge_new": "nový",
		"price_not_available": "Cena není přechodně k dispozici",
		"btn_buy_now": "Kupte nyní",
		"badge_video": "video",
		"incremental_version": "Vše, co nabízí {{prevProductName}} a další:",
		"prices_starting_from": "Ceny začínají na",
		"per_workstation_zero": "na pracovní stanici",
		"per_workstation_one": "na pracovní stanici",
		"per_workstation_other": "na pracovní stanici (minimálně {{count}})",
		"license_duration_months_one": "1 měsíc",
		"license_duration_months_other": "{{count}} měsíců",
		"license_duration": "Doba platnosti licence",
		"license_duration_infinite": "Trvalá licence",
		"license_already_active": "Aktivní",
		"license_already_active_until": "Předplatné do {{date}}",
		"vat": "DPH"
	},
	yes: "ano",
	no: "ne",
	next: "Další",
	back: "Zpět",
	language: "Jazyk",
	preferences: "Předvolby",
	go_back: "Krok zpět",
	open: "Otevřít",
	close: "Zavřít",
	login: "Přihlásit",
	no_video_found: "Video nenalezeno.",
	watch_playlist_on_youtube: "Podívejte se na videa na YouTube",
	search_video: "Hledat video",
	logout: "Odhlásit",
	admin_panel: "Panel systému",
	my_products: "Mé výrobky",
	profile: "Profil",
	starting_from: "Začínající od",
	address: "Adresa",
	more_info: "Více informací",
	click_to_expand: "Kliknout pro rozbalení",
	skip: "Skok",
	signup: "Přihlásit",
	loading: "Nahrávání...",
	cookie_policy: "Nastavení cookie",
	privacy_policy: "Nastavení soukromí",
	warning: "Varování",
	error: "Chyba",
	no_results: "Nebyly nalezeny žádné výsledky.",
	read_more: "Přečtěte si více",
	recaptcha: "Chráněno ověřením",
	captcha: {
		"error_generic": "Nelze ověřit. Prosím, znovu načtěte stránku a zkuste to znovu.",
		"error_threshold": "Zdá se, že nejste člověk. Počkejte prosím několik minut a zkuste to znovu."
	},
	feed_not_available: "Krmivo není k dispozici",
	no_elements_found: "Nebyly nalezeny žádné prvky",
	previous_page: "Předchozí",
	next_page: "Další",
	docenti: "Učitelé",
	yearly: "Roční",
	monthly: "Měsíční",
	share_on: "Sdílet na",
	show_more: "Zobrazit více...",
	show_less: "Ukaž méně",
	share_with_friend: "Sdílet s přítelem",
	copy_link: "Kopírovat odkaz",
	copied: "Zkopírováno",
	generic_error: "Při načítání této oblasti došlo k chybě.",
	elapsed_time: {
		"seconds_one": "Před 1 sekundou",
		"seconds_other": "před {{count}} sekundami",
		"minutes_one": "Před 1 minutou",
		"minutes_other": "{{count}} minut před",
		"hours_one": "Před 1 hodinou",
		"hours_other": "{{count}} před hodinami",
		"days_one": "Před 1 dnem",
		"days_other": "{{count}} dny zpět",
		"months_one": "Před 1 měsícem",
		"months_other": "{{count}} před měsícem",
		"years_one": "Před 1 rokem",
		"years_other": "{{count}} před lety"
	},
	video: {
		"next": "Další",
		"prev": "Předchozí",
		"no_videos_found": "Nebyla nalezena žádná videa",
		"watch_on_yt": "Sledujte na Youtube",
		"cookie_consent": "Pro přehrání tohoto videa je nutné přijmout soubory cookie",
		"watch_video": "Podívejte se na video",
		"muted_notice": "Zvuk je ztlumen — kliknutím jej zapnete",
		"unmute": "Zapnout zvuk"
	},
	reviews: {
		"title": "Recenze",
		"filterLabels": {
			"province": "Stát",
			"sortBy": "Objednat podle",
			"rating": "Hodnotit",
			"course": "Kurz",
			"product": "Produkt",
			"lang": "Jazyk"
		},
		"bad": "Špatný",
		"poor": "Špatný",
		"average": "Průměr",
		"great": "Skvělé",
		"excellent": "Vynikající",
		"verified_by_trustpilot": "Na základě {{count}} ověřených recenzí na Trustpilot",
		"read_more": "Přečtěte si více",
		"read_less": "Více informací",
		"review_date": "Recenze {{date}}",
		"average_out_of": "{{average}} z {{max}}",
		"statistics_label_one": "1 hvězdička",
		"statistics_label_other": "{{count}} hvězdičky",
		"empty_set": "Žádné recenze"
	},
	filters: {
		"sort_by": "Ordinace na",
		"filter": "Filtr"
	},
	courses: {
		"next_live": "Živě",
		"at_time": "na adrese",
		"promo_label": "{{perc}}% sleva",
		"free_signup": "Zaregistrujte se zdarma",
		"course_signup": "Přihlaste se do kurzu",
		"free": "Zdarma",
		"buy_for_price": "Koupit za {{price}} {{symbol}}",
		"no_course_found": "Nebyl nalezen žádný kurz",
		"signin": "Přihlásit se",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 hodina",
		"duration_hours_other": "{{count}} hodin",
		"total_duration": "{{duration}} celkem",
		"instead_of": "místo",
		"promo_expires_on": "Platnost propagační akce končí dne {{date}}",
		"lessons": {
			"session_n": "Relace n. {{sortOrder}}",
			"start_at": ", hodin",
			"teachers_one": "Lektor: {{names}}",
			"teachers_other": "Lektoři: {{names}}",
			"uploaded_at": "Datum nahrání: {{date}}",
			"other_content": "Další obsah"
		},
		"course_code": "Kód kurzu: {{code}}",
		"live_on": "Živě online ve dnech {{date}}",
		"live_from_to": "Živě online od {{from}} do {{to}}}",
		"cfp_ack": "Ocenění {{count}} kredity",
		"cfp_deadline": "Uzávěrka CFP {{date}}",
		"reviews_avg": "Průměrné hodnocení {{average}} z {{total}}",
		"reviews_count_one": "1 recenze",
		"reviews_count_other": "{{count}} recenzí",
		"sinf_approval": "Schválení SINF",
		"cnappc_approval": "Schválení CNAPPC",
		"filter": "Filtry",
		"lessons_count_one": "1 lekce",
		"lessons_count_other": "{{count}} lekcí",
		"lessons_duration_one": "1 lekce {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lekcí {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 lekce {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lekcí {{timePerLesson}}",
		"single_course": "Jeden kurz",
		"add_vat": "+ DPH",
		"vat_included": "Včetně DPH",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Nebyly nalezeny žádné položky" },
	pagination: { "next": "Další" },
	search: {
		"clear": "Přehledné vyhledávání",
		"placeholder": "Vyhledávání"
	},
	currency: { "label": "Měna" },
	alerts: {
		"confirm_consultancy": {
			"title": "Žádost odeslána",
			"message": "Vaši žádost o konzultaci jsme obdrželi. Odborník vás bude brzy kontaktovat."
		},
		"consultancy_confirmed": {
			"title": "Konzultace potvrzena",
			"message": "Vaše platba byla přijata a konzultace je potvrzena."
		},
		"login_success": {
			"title": "Vítejte zpět",
			"message": "Byli jste přihlášeni."
		},
		"login_error": {
			"title": "Přihlášení se nezdařilo",
			"message": "Něco se pokazilo. Prosím, zkuste znovu."
		},
		"logout_success": {
			"title": "Odhlášení proběhlo",
			"message": "Byli jste odhlášeni."
		}
	}
};
var languages_default$11 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$10 = {
	download: { "wait_download": "<0>Der Download sollte in wenigen Sekunden beginnen. Wenn es nicht automatisch startet, <1>klicken Sie hier</1> , um die Datei herunterzuladen.</0>" },
	form: {
		"required": "Dieses Bereich wird benötigt",
		"minLength": "Geben Sie mindestens {{num}} Zeichen ein",
		"maxLength": "Es sind maximal {{num}} Zeichen erlaubt",
		"pattern": "Der Wert ist ungültig",
		"min": "Zulässiger Mindestwert: {{num}}",
		"max": "Maximal zulässiger Wert: {{num}}",
		"add_file": "Datei hinzufügen",
		"too_many_files": "Zu viele Dateien",
		"too_few_files": "Zu wenige Dateien",
		"file_too_big": "Die ausgewählte Datei ist zu groß",
		"invalid_file": "Die ausgewählte Datei ist ungültig",
		"max_files": "Maximale Anzahl von Dateien",
		"min_files": "Mindestanzahl von Dateien",
		"types_allowed": "Dateien erlaubt",
		"max_weight": "Maximale Dateigröße",
		"submit_file_is_uploading": "Sie müssen warten, bis der Upload abgeschlossen ist, bevor Sie Ihr Formular absenden.",
		"upload_error": "Beim Hochladen Ihrer Datei ist etwas schief gelaufen. Bitte versuche es erneut",
		"submit_validation_error": "Beim Absenden Ihres Formulars ist etwas schief gelaufen. Bitte überprüfen Sie Ihre Daten und versuchen Sie es erneut.",
		"submit_error": "Beim Absenden Ihres Formulars ist etwas schief gelaufen. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte.",
		"privacy": "Ich habe die <1><0>Datenschutzerklärung</0></1> gelesen und stimme ihr zu",
		"terms": "Ich habe die <1>Nutzungsbedingungen</1> gelesen und stimme ihnen zu.",
		"login_prefill": "<0>Anmelden</0>, um Ihre Informationen automatisch in das Formular einzutragen.",
		"signup_suggestion": "<0>Melden Sie sich jetzt an</0>, um Ihre Daten in unseren Formularen vorab auszufüllen!",
		"captcha_not_resolved": "Sie müssen bestätigen, dass Sie ein Mensch sind, bevor Sie Ihr Formular absenden.",
		"captcha_not_ready": "Das Captcha ist nicht bereit. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
		"invalid_phone_prefix": "Präfix ungültig",
		"invalid_email": "Email adresse nicht gültig",
		"select": {
			"create": "{userInput}",
			"loading": "Wird geladen...",
			"no_options": "Keine Optionen gefunden"
		},
		"invalid_phone": "Die Telefonnummer ist ungültig",
		"doesnt_match": "Die eingegebenen Werte stimmen nicht überein",
		"meeting": {
			"duration": "Dauer: {{duration}}",
			"duration_label": "Dauer",
			"duration_minutes": "{{minutes}} Min.",
			"loading": "Verfügbarkeit wird geladen…",
			"empty": "Derzeit keine Verfügbarkeit.",
			"no_slots": "Für das ausgewählte Datum sind keine Uhrzeiten verfügbar.",
			"back": "Zurück zum Kalender",
			"change": "Datum/Uhrzeit ändern",
			"timezone": "Zeitzone: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Montag",
					"short": "Mo"
				},
				"tuesday": {
					"long": "Dienstag",
					"short": "Di"
				},
				"wednesday": {
					"long": "Mittwoch",
					"short": "Mi"
				},
				"thursday": {
					"long": "Donnerstag",
					"short": "Do"
				},
				"friday": {
					"long": "Freitag",
					"short": "Fr"
				},
				"saturday": {
					"long": "Samstag",
					"short": "Sa"
				},
				"sunday": {
					"long": "Sonntag",
					"short": "So"
				}
			}
		},
		"slots": {
			"add": "Termin hinzufügen",
			"remove": "Entfernen",
			"timezone": "Zeitzone: {{timezone}}",
			"min": "Bitte geben Sie mindestens {{num}} Termine an.",
			"max": "Sie können höchstens {{num}} Termine angeben.",
			"item": "Verfügbarkeit {{number}}"
		}
	},
	pricing: {
		"recommended": "Empfohlen",
		"discounted_to": "Angebot endet am {{date}}",
		"per_month": "Monat",
		"per_year": "Jahr",
		"free": "FREE",
		"badge_new": "neu",
		"price_not_available": "Preis vorübergehend nicht verfügbar",
		"btn_buy_now": "Kaufe jetzt",
		"badge_video": "Video",
		"incremental_version": "Alles, was mit {{prevProductName}} und mehr angeboten wird:",
		"prices_starting_from": "Preise ab",
		"per_workstation_zero": "pro Arbeitsplatz",
		"per_workstation_one": "pro Arbeitsplatz",
		"per_workstation_other": "pro Arbeitsplatz (mindestens {{count}})",
		"license_duration_months_one": "1 Monat",
		"license_duration_months_other": "{{count}} Monate",
		"license_duration": "Dauer der Lizenz",
		"license_duration_infinite": "Unbefristete Lizenz",
		"license_already_active": "Aktiv",
		"license_already_active_until": "Abonniert bis zum {{date}}",
		"vat": "MwSt"
	},
	yes: "Ja",
	no: "Nein",
	next: "Nächste",
	back: "Zurück",
	language: "Sprache",
	preferences: "Einstellungen",
	go_back: "Geh zurück",
	open: "Offen",
	close: "schließen",
	login: "Login",
	no_video_found: "Kein Video gefunden.",
	watch_playlist_on_youtube: "Sehen Sie sich die gesamte Playlist auf YouTube an",
	search_video: "Videos suchen",
	logout: "Logout",
	admin_panel: "Admin Paneele",
	my_products: "Meine Produkte",
	profile: "Profil",
	starting_from: "Ab",
	address: "Adresse",
	more_info: "Mehr Informationen",
	click_to_expand: "Zum erweitern klicken",
	skip: "überspringen",
	signup: "Anmelden",
	loading: "Wird geladen...",
	cookie_policy: "Cookie-Richtlinie",
	privacy_policy: "Datenschutz-Bestimmungen",
	warning: "Warnung",
	error: "Fehler",
	no_results: "Keine Ergebnisse gefunden.",
	read_more: "Mehr lesen",
	recaptcha: "Geschützt durch reCAPTCHA",
	captcha: {
		"error_generic": "Das Captcha konnte nicht überprüft werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
		"error_threshold": "Es scheint, dass du kein Mensch bist. Bitte warten Sie ein paar Minuten und versuchen Sie es erneut."
	},
	feed_not_available: "Feed nicht verfügbar",
	no_elements_found: "Keine Elemente gefunden",
	previous_page: "Vorherige",
	next_page: "Nächste",
	docenti: "Lehrerinnen und Lehrer",
	yearly: "Jährlich",
	monthly: "Monatlich",
	share_on: "Teilen auf",
	show_more: "Zeig mehr...",
	show_less: "Zeige weniger",
	share_with_friend: "Mit einem Freund teilen",
	copy_link: "Link kopieren",
	copied: "Kopiert",
	generic_error: "Beim Laden dieses Bereichs ist ein Fehler aufgetreten.",
	elapsed_time: {
		"seconds_one": "vor 1 Sekunde",
		"seconds_other": "vor {count}} Sekunden",
		"minutes_one": "vor 1 Minute",
		"minutes_other": "vor {{count}} Minuten",
		"hours_one": "vor 1 Stunde",
		"hours_other": "vor {{count}} Stunden",
		"days_one": "vor 1 Tag",
		"days_other": "vor {{count}} Tagen",
		"months_one": "vor 1 Monat",
		"months_other": "vor {{count}} Monaten",
		"years_one": "vor 1 Jahr",
		"years_other": "vor {{count}} Jahren"
	},
	video: {
		"next": "Weiter",
		"prev": "Vorherige",
		"no_videos_found": "Keine Videos gefunden",
		"watch_on_yt": "Auf Youtube ansehen",
		"cookie_consent": "Um dieses Video anzusehen, müssen Sie Cookies akzeptieren",
		"watch_video": "Video ansehen",
		"muted_notice": "Der Ton ist stummgeschaltet — zum Aktivieren klicken",
		"unmute": "Ton aktivieren"
	},
	reviews: {
		"title": "Bewertungen",
		"filterLabels": {
			"province": "Staat",
			"sortBy": "Bestellen nach",
			"rating": "Bewerten Sie",
			"course": "Kurs",
			"product": "Produkt",
			"lang": "Sprache"
		},
		"bad": "Schlecht",
		"poor": "Schlecht",
		"average": "Durchschnitt",
		"great": "Großartig",
		"excellent": "Ausgezeichnet",
		"verified_by_trustpilot": "Auf der Grundlage von {{count}} verifizierten Bewertungen bei Trustpilot",
		"read_more": "Lesen Sie mehr",
		"read_less": "Weniger lesen",
		"review_date": "Rezensionen zum {{date}}",
		"average_out_of": "{{average}} aus {{max}}",
		"statistics_label_one": "1 Sternchen",
		"statistics_label_other": "{{count}} Sterne",
		"empty_set": "Keine Bewertungen"
	},
	filters: {
		"sort_by": "Sortieren nach",
		"filter": "Filter"
	},
	courses: {
		"next_live": "Live",
		"at_time": "unter",
		"promo_label": "{{perc}}% Rabatt",
		"free_signup": "Kostenlos anmelden",
		"course_signup": "Für den Kurs anmelden",
		"free": "Kostenlos",
		"buy_for_price": "Kaufen für {{price}} {{symbol}}",
		"no_course_found": "Kein Kurs gefunden",
		"signin": "Eintragen",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 Stunde",
		"duration_hours_other": "{{count}} Stunden",
		"total_duration": "{{duration}} insgesamt",
		"instead_of": "anstelle von",
		"promo_expires_on": "Promo läuft am {{date}} ab",
		"lessons": {
			"session_n": "Sitzung n. {{sortOrder}}",
			"start_at": ", Stunden",
			"teachers_one": "Dozent: {{names}}",
			"teachers_other": "Dozenten: {{names}}",
			"uploaded_at": "Hochgeladen am: {{date}}",
			"other_content": "Weitere Inhalte"
		},
		"course_code": "Kurs-Code: {{code}}",
		"live_on": "Live online am {{date}}",
		"live_from_to": "Live online von {{from}} bis {{to}}",
		"cfp_ack": "Auszeichnungen {{count}} Kredite",
		"cfp_deadline": "CFP-Frist {{date}}",
		"reviews_avg": "Bewertungen durchschnittlich {{average}} von {{total}}",
		"reviews_count_one": "1 Rezension",
		"reviews_count_other": "{{count}} Bewertungen",
		"sinf_approval": "SINF-Zulassung",
		"cnappc_approval": "CNAPPC-Zulassung",
		"filter": "Filter",
		"lessons_count_one": "1 Lektion",
		"lessons_count_other": "{{count}} Lektionen",
		"lessons_duration_one": "1 Lektion von {{timePerLesson}} + {{timePerTest}} Test",
		"lessons_duration_other": "{{count}} Lektionen von {{timePerLesson}} + {{timePerTest}} Test",
		"lessons_duration_no_test_one": "1 Lektion von {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} Lektionen von {{timePerLesson}}",
		"single_course": "Einzelner Kurs",
		"add_vat": "+ MwSt",
		"vat_included": "inkl. MwSt",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Keine Artikel gefunden" },
	pagination: { "next": "Weiter" },
	search: {
		"clear": "Suche löschen",
		"placeholder": "Suche"
	},
	currency: { "label": "Währung" },
	alerts: {
		"confirm_consultancy": {
			"title": "Anfrage gesendet",
			"message": "Wir haben Ihre Beratungsanfrage erhalten. Der Fachmann wird Sie in Kürze kontaktieren."
		},
		"consultancy_confirmed": {
			"title": "Beratung bestätigt",
			"message": "Ihre Zahlung ist eingegangen und Ihre Beratung ist bestätigt."
		},
		"login_success": {
			"title": "Willkommen zurück",
			"message": "Du bist jetzt angemeldet."
		},
		"login_error": {
			"title": "Anmeldung fehlgeschlagen",
			"message": "Etwas ist schief gelaufen. Bitte versuche es erneut."
		},
		"logout_success": {
			"title": "Abgemeldet",
			"message": "Du wurdest abgemeldet."
		}
	}
};
var languages_default$10 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$9 = {
	download: { "wait_download": "<0>Download should starts in a few seconds. If it doesn't start automatically, <1>click here</1> to download the file.</0>" },
	form: {
		"required": "This field is required",
		"minLength": "Type at least {{num}} characters",
		"maxLength": "Max {{num}} characters are allowed",
		"pattern": "The value is not valid",
		"min": "Minimum value allowed: {{num}}",
		"max": "Maximum value allowed: {{num}}",
		"add_file": "Add file",
		"too_many_files": "Too many files",
		"too_few_files": "Too few files",
		"file_too_big": "The selected file is too big",
		"invalid_file": "The selected file is not valid",
		"max_files": "Max number of files",
		"min_files": "Min number of files",
		"types_allowed": "Files allowed",
		"max_weight": "Max file size",
		"submit_file_is_uploading": "You need to wait for the upload to finish before submitting your form.",
		"upload_error": "Something went wrong while uploading your file. Please, try again.",
		"submit_validation_error": "Something went wrong while submitting your form. Please, check your data and try again.",
		"submit_error": "Something went wrong while submitting your form. If the problem persists, please contact us.",
		"privacy": "I have read and agreed to the <1><0>Privacy Policy</0></1>",
		"terms": "I have read and agreed to the <1>terms and conditions</1>.",
		"login_prefill": "<0>Login</0> to automatically fill your information in the form.",
		"signup_suggestion": "<0>Sign up now</0> to pre-fill your data in our forms!",
		"captcha_not_resolved": "You have to confirm that you are a human before submitting your form.",
		"captcha_not_ready": "The captcha is not ready. Please reload the page and try again.",
		"invalid_phone_prefix": "Prefix not valid",
		"invalid_email": "Email address not valid",
		"select": {
			"create": "{userInput}",
			"loading": "Loading...",
			"no_options": "No options found"
		},
		"invalid_phone": "The phone number is invalid",
		"doesnt_match": "The inserted values don't correspond",
		"meeting": {
			"duration": "Duration: {{duration}}",
			"duration_label": "Duration",
			"duration_minutes": "{{minutes}} min",
			"loading": "Loading availability…",
			"empty": "No availability at the moment.",
			"no_slots": "No times available for the selected date.",
			"back": "Back to calendar",
			"change": "Change date/time",
			"timezone": "Timezone: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Monday",
					"short": "Mon"
				},
				"tuesday": {
					"long": "Tuesday",
					"short": "Tue"
				},
				"wednesday": {
					"long": "Wednesday",
					"short": "Wed"
				},
				"thursday": {
					"long": "Thursday",
					"short": "Thu"
				},
				"friday": {
					"long": "Friday",
					"short": "Fri"
				},
				"saturday": {
					"long": "Saturday",
					"short": "Sat"
				},
				"sunday": {
					"long": "Sunday",
					"short": "Sun"
				}
			}
		},
		"slots": {
			"add": "Add a time slot",
			"remove": "Remove",
			"timezone": "Time zone: {{timezone}}",
			"min": "Please choose at least {{num}} time slots.",
			"max": "You can choose at most {{num}} time slots.",
			"item": "Availability {{number}}"
		}
	},
	pricing: {
		"recommended": "Recommended",
		"discounted_to": "Promotion ends {{date}}",
		"per_month": "month",
		"per_year": "year",
		"free": "FREE",
		"badge_new": "new",
		"price_not_available": "Price temporarily not available",
		"btn_buy_now": "Buy now",
		"badge_video": "video",
		"incremental_version": "Everything offered with {{prevProductName}} and more:",
		"prices_starting_from": "Prices starting from",
		"per_workstation_zero": "per workstation",
		"per_workstation_one": "per workstation",
		"per_workstation_other": "per workstation (minimum {{count}})",
		"license_duration_months_one": "1 month",
		"license_duration_months_other": "{{count}} months",
		"license_duration": "License duration",
		"license_duration_infinite": "Perpetual license",
		"license_already_active": "Active",
		"license_already_active_until": "Subscribed until {{date}}",
		"vat": "VAT"
	},
	yes: "yes",
	no: "no",
	next: "Next",
	back: "Back",
	language: "Language",
	preferences: "Preferences",
	go_back: "Go back",
	open: "Open",
	close: "Close",
	login: "Login",
	no_video_found: "No video found.",
	watch_playlist_on_youtube: "Watch the entire playlist on YouTube",
	search_video: "Search video",
	logout: "Logout",
	admin_panel: "Admin panel",
	my_products: "My products",
	profile: "Profile",
	starting_from: "Starting from",
	address: "Address",
	more_info: "More information",
	click_to_expand: "Click to expand",
	skip: "Skip",
	signup: "Signup",
	loading: "Loading...",
	cookie_policy: "Cookie policy",
	privacy_policy: "Privacy policy",
	warning: "Warning",
	error: "Error",
	no_results: "No results found.",
	read_more: "Read more",
	recaptcha: "Protected by reCAPTCHA",
	captcha: {
		"error_generic": "Unable to verify the captcha. Please, reload the page and try again.",
		"error_threshold": "It seems you're not a human. Please, wait a few minutes and try again."
	},
	feed_not_available: "Feed not available",
	no_elements_found: "No elements found",
	previous_page: "Previous",
	next_page: "Next",
	docenti: "Teachers",
	yearly: "Yearly",
	monthly: "Monthly",
	share_on: "Share on",
	show_more: "Show more...",
	show_less: "Show less",
	share_with_friend: "Share with a friend",
	copy_link: "Copy link",
	copied: "Copied",
	generic_error: "An error occurred while loading this area.",
	elapsed_time: {
		"seconds_one": "1 second ago",
		"seconds_other": "{{count}}\xA0seconds ago",
		"minutes_one": "1 minute ago",
		"minutes_other": "{{count}}\xA0minutes ago",
		"hours_one": "1 hour ago",
		"hours_other": "{{count}}\xA0hours ago",
		"days_one": "1 day ago",
		"days_other": "{{count}}\xA0days ago",
		"months_one": "1 month ago",
		"months_other": "{{count}}\xA0months ago",
		"years_one": "1 year ago",
		"years_other": "{{count}}\xA0years ago"
	},
	video: {
		"next": "Next",
		"prev": "Previous",
		"no_videos_found": "No videos found",
		"watch_on_yt": "Watch on Youtube",
		"cookie_consent": "You need to accept cookies to watch this video",
		"watch_video": "Watch Video",
		"muted_notice": "Audio is muted — click to turn on sound",
		"unmute": "Turn on sound"
	},
	reviews: {
		"title": "Reviews",
		"filterLabels": {
			"province": "State",
			"sortBy": "Order by",
			"rating": "Rating",
			"course": "Course",
			"product": "Product",
			"lang": "Language"
		},
		"bad": "Bad",
		"poor": "Poor",
		"average": "Average",
		"great": "Great",
		"excellent": "Excellent",
		"verified_by_trustpilot": "Based on {{count}} verified reviews on Trustpilot",
		"read_more": "Read more",
		"read_less": "Read less",
		"review_date": "Review of {{date}}",
		"average_out_of": "{{average}} out of {{max}}",
		"statistics_label_one": "1 star",
		"statistics_label_other": "{{count}} stars",
		"empty_set": "No reviews"
	},
	filters: {
		"sort_by": "Sort by",
		"filter": "Filter"
	},
	courses: {
		"next_live": "Live",
		"at_time": "at",
		"promo_label": "{{perc}}% discount",
		"free_signup": "Signup for free",
		"course_signup": "Sign up for the course",
		"free": "Free",
		"buy_for_price": "Buy for {{price}} {{symbol}}",
		"no_course_found": "No course found",
		"signin": "Sign in",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 hour",
		"duration_hours_other": "{{count}} hours",
		"total_duration": "{{duration}} total",
		"instead_of": "instead of",
		"promo_expires_on": "Promo expires on {{date}}",
		"lessons": {
			"session_n": "Session n. {{sortOrder}}",
			"start_at": ", hours",
			"teachers_one": "Teacher: {{names}}",
			"teachers_other": "Teachers: {{names}}",
			"uploaded_at": "Upload date: {{date}}",
			"other_content": "Other content",
			"blocked_watch_files_webinar": "Course materials are only available after watching the live lesson.",
			"blocked_watch_files_video": "Course materials are only available after watching the lesson recording.",
			"blocked_watch_quiz_webinar": "The test is only available after watching the live lesson.",
			"blocked_watch_quiz_video": "The test is only available after watching the lesson recording.",
			"blocked_sequential_lesson_webinar": "Lesson webinars are only available after passing the previous lessons' tests.",
			"blocked_sequential_lesson_video": "Lesson videos are only available after passing the previous lessons' tests.",
			"blocked_sequential_files": "Lesson materials are only available after passing the previous lessons' tests.",
			"blocked_sequential_quiz": "Lesson tests are only available after passing the previous lessons' tests.",
			"empty_video": "No video available for this lesson.",
			"empty_materials": "No teaching material for this lesson.",
			"open_external": "Open the external content",
			"open_lesson": "Open lesson",
			"back_to_course": "Open course",
			"download_material": "Click here to download the material",
			"preview_disclaimer_office": "The preview may differ from the actual content, we recommend downloading the file.",
			"preview_error": "Preview not available. Download the file to view it.",
			"preview_loading": "Loading preview…"
		},
		"course_code": "Course code: {{code}}",
		"live_on": "Live online on {{date}}",
		"live_from_to": "Live online from {{from}} to {{to}}",
		"cfp_ack": "Awards {{count}} credits",
		"cfp_deadline": "CFP deadline {{date}}",
		"reviews_avg": "Reviews average {{average}} out of {{total}}",
		"reviews_count_one": "1 review",
		"reviews_count_other": "{{count}} reviews",
		"sinf_approval": "SINF approval",
		"cnappc_approval": "CNAPPC approval",
		"filter": "Filters",
		"lessons_count_one": "1 lesson",
		"lessons_count_other": "{{count}} lessons",
		"lessons_duration_one": "1 lesson of {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lessons of {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 lesson of {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lessons of {{timePerLesson}}",
		"single_course": "Single course",
		"add_vat": "+ VAT",
		"vat_included": "VAT included",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})",
		"trial_request_button": "Request activation",
		"trial_waiting_button": "Request in progress",
		"trial_waiting_hint": "Waiting for the order to complete: come back once it is done, or try again later.",
		"trial_requested_button": "Request sent",
		"trial_requested_hint": "Your request is being processed. You will be notified as soon as your licence is issued.",
		"trial_licensed_button": "Licence already active",
		"trial_duration_one": "{{count}} month",
		"trial_duration_other": "{{count}} months",
		"trial_duration_course": "For the duration of the course",
		"trial_banner_requested_title": "Request sent",
		"trial_banner_requested_body": "We have recorded your order. The temporary licence will be available shortly and will stay valid for the stated duration.",
		"trial_banner_already_title": "Request already recorded",
		"trial_banner_already_body": "This request was already sent: nothing else to do.",
		"trial_banner_expired_title": "Session expired",
		"trial_banner_expired_body": "The checkout expired before completing: wait a few minutes and try again.",
		"trial_licensed_trial_until": "Trial version active and valid until {{date}}.",
		"trial_licensed_trial_perpetual": "Trial version active with no expiry.",
		"trial_licensed_other_until": "You already hold an active licence for {{product}} until {{date}}.",
		"trial_licensed_other_perpetual": "You already hold an active licence for {{product}} (no expiry).",
		"trial_requested_expired_button": "Licence already requested",
		"trial_requested_expired_body": "The trial version was already requested in the past and expired on {{date}}."
	},
	feed: { "no_items_found": "No Items found" },
	pagination: { "next": "Next" },
	data_table: {
		"sort_ascending": "Sort by {{column}}, ascending",
		"sort_descending": "Sort by {{column}}, descending",
		"sort_clear": "Remove the sorting by {{column}}"
	},
	search: {
		"clear": "Clear search",
		"placeholder": "Search"
	},
	currency: { "label": "Currency" },
	consultancies: {
		"book_from_price": "Book from {{price}} {{symbol}}/hour",
		"view_profile": "View profile",
		"curriculum": "Curriculum",
		"no_consultant_found": "No consultant found",
		"hourly_rate": "Hourly rate: {{price}} {{symbol}}",
		"add_vat": "+ VAT",
		"booking_unavailable": "Bookings for this consultant are not available at the moment.",
		"requests_empty": "You have not received any consultancy request yet.",
		"requests_hours": "Hours",
		"requests_anonymous": "Client without an account",
		"requests_filter_all": "All",
		"requests_filter_to_confirm": "To confirm",
		"requests_filter_confirmed": "Confirmed",
		"requests_filter_archived": "Archived",
		"requests_status_pending": "Awaiting confirmation",
		"requests_status_scheduled": "Awaiting payment",
		"requests_status_paid": "Paid",
		"requests_status_completed": "Completed",
		"requests_status_rejected": "Rejected",
		"requests_status_expired": "Expired",
		"requests_proposed_slots": "Proposed availability",
		"requests_scheduled_at": "Appointment",
		"requests_created_at": "Requested",
		"requests_price": "Price",
		"requests_deadline": "Deadline",
		"requests_paid_at": "Paid on",
		"requests_rejected_at": "Rejected on",
		"requests_expired_at": "Expired on",
		"requests_payment_link": "Payment link",
		"requests_copy_payment_link": "Copy payment link",
		"requests_copied": "Copied",
		"requests_confirm": "Confirm",
		"requests_reconfirm": "Re-confirm",
		"requests_reject": "Reject",
		"requests_reject_action": "Reject",
		"requests_confirm_title": "Confirm consultancy",
		"requests_confirm_datetime": "Agreed date and time",
		"requests_confirm_hours": "Hours",
		"requests_confirm_submit": "Send payment request",
		"requests_cancel": "Cancel",
		"requests_confirm_success": "The payment request has been sent.",
		"requests_reject_success": "The consultancy request has been rejected.",
		"requests_reject_confirm": "Reject this consultancy request?",
		"requests_datetime_invalid": "Choose a valid future date and time.",
		"requests_hours_invalid": "Enter a positive whole number of hours.",
		"requests_action_error": "The request could not be completed. Please try again.",
		"requests_booker": "Requester",
		"requests_detail": "Request",
		"requests_status": "Status",
		"requests_actions": "Actions",
		"requests_table_caption": "Consultancy requests received",
		"requests_tab_all": "All",
		"requests_tab_to_confirm": "To confirm",
		"requests_tab_scheduled": "Scheduled",
		"requests_tab_completed": "Completed",
		"requests_tab_archived": "Rejected and expired",
		"requests_datetime": "Date / Time",
		"requests_customer": "Customer",
		"requests_duration": "Duration",
		"requests_duration_one": "1 hour",
		"requests_duration_other": "{{count}} hours",
		"requests_slots": "Proposed times",
		"requests_view_all": "See all ({{count}})",
		"requests_today": "Today",
		"requests_expires_relative": "expires {{relative}}",
		"requests_expires_days": "expires in {{count}} days",
		"requests_expires_tomorrow": "expires tomorrow",
		"requests_expires_hours": "expires in {{count}} hours",
		"requests_expires_minutes": "expires in {{count}} minutes",
		"requests_in_minutes": "in {{count}} minutes",
		"requests_in_hours": "in {{count}} hours",
		"requests_tomorrow": "tomorrow",
		"requests_payment_pending": "To pay",
		"requests_start_video": "Start video call",
		"requests_copy_payment": "Copy payment link",
		"requests_repropose": "Re-propose",
		"requests_compensi": "Go to fee calculation"
	},
	alerts: {
		"confirm_consultancy": {
			"title": "Request sent",
			"message": "We have received your consultancy request. The professional will contact you shortly."
		},
		"consultancy_confirmed": {
			"title": "Consultancy confirmed",
			"message": "Your payment has been received and your consultancy is confirmed."
		},
		"login_success": {
			"title": "Welcome back",
			"message": "You are now signed in."
		},
		"login_error": {
			"title": "Login failed",
			"message": "Something went wrong. Please, try again."
		},
		"logout_success": {
			"title": "Signed out",
			"message": "You have been signed out."
		}
	}
};
var languages_default$9 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$8 = {
	download: { "wait_download": "<0>La descarga debería comenzar en unos segundos. Si no se inicia automáticamente, <1>haga click aquí</1> para descargar el archivo.</0>" },
	form: {
		"required": "Este campo es obligatorio",
		"minLength": "Escriba al menos {{num}} caracteres",
		"maxLength": "Se permite un máximo de {{num}} caracteres",
		"pattern": "El valor no es válido",
		"min": "Valor mínimo permitido: {{num}}",
		"max": "Valor máximo permitido: {{num}}",
		"add_file": "Añadir fichero",
		"too_many_files": "Demasiados archivos",
		"too_few_files": "Demasiado pocos archivos",
		"file_too_big": "La selección de archivos es demasiado grande",
		"invalid_file": "La selección de archivos no es válida",
		"max_files": "Número máximo de archivos",
		"min_files": "Número mínimo de archivos",
		"types_allowed": "Archivos permitidos",
		"max_weight": "Tamaño máximo de archivo",
		"submit_file_is_uploading": "Debe esperar a que la carga finalice antes de enviar el formulario.",
		"upload_error": "Algo ha ido mal durante la carga del archivo. Por favor, inténtelo de nuevo.",
		"submit_validation_error": "Algo ha ido mal durante el envío del formulario. Por favor, compruebe sus datos y pruebe de nuevo.",
		"submit_error": "Algo ha ido mal durante el envío del formulario. Si el problema persiste, por favor, póngase en contacto con nosotros.",
		"privacy": "He leído y aceptado la <1><0>Política de Privacidad</0></1>",
		"terms": "He leído y aceptado los <1><0>términos y condiciones<</0></1> ",
		"login_prefill": "<0>Inicie sesión</0> para rellenar automáticamente sus datos en el formulario.",
		"signup_suggestion": "<0>¡Regístrese ahora</0> para rellenar previamente sus datos en nuestros formularios!",
		"captcha_not_resolved": "Tienes que confirmar que eres una persona antes de enviar tu formulario.",
		"captcha_not_ready": "El captcha no está listo. Recarga la página e inténtalo de nuevo.",
		"invalid_phone_prefix": "Prefijo no válido",
		"invalid_email": "Dirección de correo electrónico no válida",
		"select": {
			"create": "{userInput}",
			"loading": "Cargando ...",
			"no_options": "No se han encuentrado opciones"
		},
		"invalid_phone": "El número telefónico es inválido",
		"doesnt_match": "Los valores introducidos no coinciden",
		"meeting": {
			"duration": "Duración: {{duration}}",
			"duration_label": "Duración",
			"duration_minutes": "{{minutes}} min",
			"loading": "Cargando disponibilidad…",
			"empty": "No hay disponibilidad en este momento.",
			"no_slots": "No hay horarios disponibles para la fecha seleccionada.",
			"back": "Volver al calendario",
			"change": "Cambiar fecha/hora",
			"timezone": "Zona horaria: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Lunes",
					"short": "Lun"
				},
				"tuesday": {
					"long": "Martes",
					"short": "Mar"
				},
				"wednesday": {
					"long": "Miércoles",
					"short": "Mié"
				},
				"thursday": {
					"long": "Jueves",
					"short": "Jue"
				},
				"friday": {
					"long": "Viernes",
					"short": "Vie"
				},
				"saturday": {
					"long": "Sábado",
					"short": "Sáb"
				},
				"sunday": {
					"long": "Domingo",
					"short": "Dom"
				}
			}
		},
		"slots": {
			"add": "Añadir disponibilidad",
			"remove": "Eliminar",
			"timezone": "Zona horaria: {{timezone}}",
			"min": "Indica al menos {{num}} disponibilidades.",
			"max": "Puedes indicar como máximo {{num}} disponibilidades.",
			"item": "Disponibilidad {{number}}"
		}
	},
	pricing: {
		"recommended": "Recomendado",
		"discounted_to": "La promoción finaliza el {{date}}",
		"per_month": "mes",
		"per_year": "año",
		"free": "GRATIS",
		"badge_new": "nuevo",
		"price_not_available": "Precio no disponible temporalmente",
		"btn_buy_now": "Comprar ahora",
		"badge_video": "vídeo",
		"incremental_version": "Todo lo que se ofrece con {{prevProductName}} y más:",
		"prices_starting_from": "Los precios comienzan en",
		"per_workstation_zero": "en la estación",
		"per_workstation_one": "en la estación",
		"per_workstation_other": "por mensaje (mínimo {{count}})",
		"license_duration_months_one": "1 mes",
		"license_duration_months_other": "{{count}} meses",
		"license_duration": "Duración de la licencia",
		"license_duration_infinite": "Licencia perpetua",
		"license_already_active": "Activo",
		"license_already_active_until": "Suscrito hasta el {{date}}",
		"vat": "IVA"
	},
	yes: "si",
	no: "no",
	next: "Siguiente",
	back: "Anterior",
	language: "Lenguaje",
	preferences: "Preferencias",
	go_back: "Volver atrás",
	open: "Abrir",
	close: "Cerrar",
	login: "Iniciar sesión",
	no_video_found: "No se ha encontrado ningún vídeo.",
	watch_playlist_on_youtube: "Vea la lista de vídeos entera en YouTube",
	search_video: "Burcar vídeo",
	logout: "Salir",
	admin_panel: "Panel de administración",
	my_products: "Mis productos",
	profile: "Perfil",
	starting_from: "Empezar desde",
	address: "Dirección",
	more_info: "Más información",
	click_to_expand: "Click para expandir",
	skip: "Omitir",
	signup: "Registrarse",
	loading: "Cargando",
	cookie_policy: "Politica de Cookies",
	privacy_policy: "Política de privacidad",
	warning: "Advertencia",
	error: "Error",
	no_results: "No se han encontrado resultados.",
	read_more: "Leer más",
	recaptcha: "Protegida por reCAPTCHA",
	captcha: {
		"error_generic": "No se puede verificar el captcha. Por favor, recarga la página y vuelve a intentarlo.",
		"error_threshold": "Parece que no eres un humano. Por favor, espere unos minutos e intente de nuevo."
	},
	feed_not_available: "Feed no disponible",
	no_elements_found: "No se encontraron elementos",
	previous_page: "Previa",
	next_page: "Próxima",
	docenti: "Profesores",
	yearly: "Anual",
	monthly: "Mensual",
	share_on: "Compartir en",
	show_more: "Mostrar más...",
	show_less: "Muestra menos",
	share_with_friend: "Compartir con un amigo",
	copy_link: "Copiar enlace",
	copied: "Copiado",
	generic_error: "Se ha producido un error al cargar esta zona.",
	elapsed_time: {
		"seconds_one": "Hace 1 segundo",
		"seconds_other": "{{count}} hace un segundo",
		"minutes_one": "Hace 1 minuto",
		"minutes_other": "Hace {{count}} minutos",
		"hours_one": "hace 1 hora",
		"hours_other": "{{count}} hace horas",
		"days_one": "Hace 1 día",
		"days_other": "{{count}} días atrás",
		"months_one": "hace 1 mes",
		"months_other": "{{count}} hace meses",
		"years_one": "hace 1 año",
		"years_other": "{{count}} hace años"
	},
	video: {
		"next": "Siguiente",
		"prev": "Anterior",
		"no_videos_found": "No se han encontrado vídeos",
		"watch_on_yt": "Ver en YouTube",
		"cookie_consent": "Para ver este vídeo es necesario aceptar las cookies",
		"watch_video": "Ver el vídeo",
		"muted_notice": "El audio está silenciado — haz clic para activarlo",
		"unmute": "Activar el sonido"
	},
	reviews: {
		"title": "Reseñas",
		"filterLabels": {
			"province": "Provincia",
			"sortBy": "Ordenar por",
			"rating": "Vote",
			"course": "Curso",
			"product": "Producto",
			"lang": "Idioma"
		},
		"bad": "Mal",
		"poor": "Pobre",
		"average": "Media",
		"great": "Muy buena",
		"excellent": "Excelente",
		"verified_by_trustpilot": "Basado en {{count}} opiniones verificadas en Trustpilot",
		"read_more": "Leer más",
		"read_less": "Leer menos",
		"review_date": "Revisión de la {{date}}",
		"average_out_of": "{{average}} en {{max}}",
		"statistics_label_one": "1 estrella",
		"statistics_label_other": "{{count}} estrellas",
		"empty_set": "No reviews"
	},
	filters: {
		"sort_by": "Ordenar por",
		"filter": "Filtro"
	},
	courses: {
		"next_live": "En directo",
		"at_time": "Horas",
		"promo_label": "{{perc}}% de descuento",
		"free_signup": "Regístrate gratis",
		"course_signup": "Inscribirse en el curso",
		"free": "Gratis",
		"buy_for_price": "Comprar a {{price}} {{symbol}}",
		"no_course_found": "No se han encontrado cursos",
		"signin": "Acceder al curso",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 hora",
		"duration_hours_other": "{{count}} horas",
		"total_duration": "{{duration}} totales",
		"instead_of": "en lugar de",
		"promo_expires_on": "La oferta caduca el {{date}}",
		"lessons": {
			"session_n": "Nº de sesión {{sortOrder}}",
			"start_at": "horas",
			"teachers_one": "Profesor: {{names}}",
			"teachers_other": "Profesores: {{names}}",
			"uploaded_at": "Fecha de subida: {{date}}",
			"other_content": "Otro contenido"
		},
		"course_code": "Código del curso: {{code}}",
		"live_on": "En directo en línea el {{date}}",
		"live_from_to": "En línea directo de {{from}} a {{to}}",
		"cfp_ack": "Reconoce {{count}} PPC",
		"cfp_deadline": "Fecha límite del PPC {{date}}",
		"reviews_avg": "Media de votos {{average}} sobre {{total}}",
		"reviews_count_one": "1 Evaluación",
		"reviews_count_other": "{{count}} valoraciones",
		"sinf_approval": "Aprobación SINF",
		"cnappc_approval": "Aprobación CNAPPC",
		"filter": "Filtros",
		"lessons_count_one": "1 lección",
		"lessons_count_other": "{{count}} lecciones",
		"lessons_duration_one": "1 lección de {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lecciones de {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 lección de {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lecciones de {{timePerLesson}}",
		"single_course": "Curso único",
		"add_vat": "+ IVA",
		"vat_included": "VAT incluido",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "No se han encontrado artículos" },
	pagination: { "next": "Página siguiente" },
	search: {
		"clear": "Restablecer búsqueda",
		"placeholder": "Buscar en"
	},
	currency: { "label": "Moneda" },
	alerts: {
		"confirm_consultancy": {
			"title": "Solicitud enviada",
			"message": "Hemos recibido tu solicitud de asesoría. El profesional se pondrá en contacto contigo en breve."
		},
		"consultancy_confirmed": {
			"title": "Consulta confirmada",
			"message": "Hemos recibido tu pago y tu consulta está confirmada."
		},
		"login_success": {
			"title": "Bienvenido de nuevo",
			"message": "Has iniciado sesión."
		},
		"login_error": {
			"title": "Error al iniciar sesión",
			"message": "Algo fue mal. Por favor, inténtelo de nuevo."
		},
		"logout_success": {
			"title": "Sesión cerrada",
			"message": "Has cerrado sesión."
		}
	}
};
var languages_default$8 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$7 = {
	download: { "wait_download": "<0> Le téléchargement devrait commencer dans quelques secondes. S'il ne démarre pas automatiquement, <1> cliquez ici </1> pour télécharger le fichier. </0>" },
	form: {
		"required": "Ce champ est requis",
		"minLength": "Saisissez au moins {{num}}\xA0caractères",
		"maxLength": "Max {{num}}\xA0caractères sont autorisés",
		"pattern": "La valeur n'est pas valide",
		"min": "Valeur minimale autorisée: {{num}}",
		"max": "Valeur maximale autorisée: {{num}}",
		"add_file": "Ajouter le fichier",
		"too_many_files": "Trop de fichiers",
		"too_few_files": "Trop peu de fichiers",
		"file_too_big": "Le fichier sélectionné est trop grande",
		"invalid_file": "Le fichier sélectionné n'est pas valide",
		"max_files": "Nombre maximum de fichiers",
		"min_files": "Nombre minimum de fichiers",
		"types_allowed": "Fichiers autorisés",
		"max_weight": "Taille maximale du fichier",
		"submit_file_is_uploading": "Vous devez attendre la fin du téléchargement avant de soumettre votre formulaire.",
		"upload_error": "Une erreur s'est produite lors du téléchargement de votre fichier. Veuillez réessayer.",
		"submit_validation_error": "Une erreur s'est produite lors de la soumission de votre formulaire. Veuillez vérifier vos données et réessayer.",
		"submit_error": "Une erreur s'est produite lors de la soumission de votre formulaire. Si le problème persiste, veuillez nous contacter.",
		"privacy": "J'ai lu et j'accepte la <1><0>Politique de confidentialité</0></1>",
		"terms": "J'ai lu et j'accepte les <1>termes et conditions</1>.",
		"login_prefill": "<0>Connectez-vous</0> pour renseigner automatiquement vos informations dans le formulaire.",
		"signup_suggestion": "<0>Inscrivez-vous dès maintenant</0> pour pré-remplir vos données dans nos formulaires!",
		"captcha_not_resolved": "Vous devez confirmer que vous êtes un être humain avant de soumettre votre formulaire.",
		"captcha_not_ready": "Le captcha n'est pas prêt. Veuillez recharger la page et réessayer.",
		"invalid_phone_prefix": "Préfixe non valide",
		"invalid_email": "Adresse email non valide",
		"select": {
			"create": "{userInput}",
			"loading": "Chargement...",
			"no_options": "Aucune option trouvée"
		},
		"invalid_phone": "Le numéro de téléphone est invalide",
		"doesnt_match": "Les valeurs saisies ne correspondent pas",
		"meeting": {
			"duration": "Durée : {{duration}}",
			"duration_label": "Durée",
			"duration_minutes": "{{minutes}} min",
			"loading": "Chargement des disponibilités…",
			"empty": "Aucune disponibilité pour le moment.",
			"no_slots": "Aucun horaire disponible pour la date sélectionnée.",
			"back": "Retour au calendrier",
			"change": "Modifier la date/l'heure",
			"timezone": "Fuseau horaire : {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Lundi",
					"short": "Lun"
				},
				"tuesday": {
					"long": "Mardi",
					"short": "Mar"
				},
				"wednesday": {
					"long": "Mercredi",
					"short": "Mer"
				},
				"thursday": {
					"long": "Jeudi",
					"short": "Jeu"
				},
				"friday": {
					"long": "Vendredi",
					"short": "Ven"
				},
				"saturday": {
					"long": "Samedi",
					"short": "Sam"
				},
				"sunday": {
					"long": "Dimanche",
					"short": "Dim"
				}
			}
		},
		"slots": {
			"add": "Ajouter une disponibilité",
			"remove": "Supprimer",
			"timezone": "Fuseau horaire : {{timezone}}",
			"min": "Indiquez au moins {{num}} disponibilités.",
			"max": "Vous pouvez indiquer au maximum {{num}} disponibilités.",
			"item": "Disponibilité {{number}}"
		}
	},
	pricing: {
		"recommended": "conseillé",
		"discounted_to": "La promotion se termine le {{date}}",
		"per_month": "Mois",
		"per_year": "Année",
		"free": "FREE",
		"badge_new": "new",
		"price_not_available": "Prix ​​temporairement indisponible",
		"btn_buy_now": "Acheter maintenant",
		"badge_video": "video",
		"incremental_version": "Tout ce qui est offert avec {{prevProductName}} et plus encore :",
		"prices_starting_from": "Tarifs à partir de",
		"per_workstation_zero": "à la station",
		"per_workstation_one": "à la station",
		"per_workstation_other": "par message (minimum {{count}})",
		"license_duration_months_one": "1 mois",
		"license_duration_months_other": "{{count}} mois",
		"license_duration": "Durée de la licence",
		"license_duration_infinite": "Licence perpétuelle",
		"license_already_active": "Actif",
		"license_already_active_until": "Abonné jusqu'au {{date}}",
		"vat": "TVA"
	},
	yes: "Oui",
	no: "No",
	next: "Suivant",
	back: "Arrière",
	language: "Langue",
	preferences: "Préférences",
	go_back: "Retourner",
	open: "Ouvrir",
	close: "Fermer",
	login: "Login",
	no_video_found: "Aucune vidéo trouvée.",
	watch_playlist_on_youtube: "Regardez toute la playlist sur YouTube",
	search_video: "Rechercher une vidéo",
	logout: "Logout",
	admin_panel: "Admin panneau",
	my_products: "Mes produits",
	profile: "Profil",
	starting_from: "Commençant par",
	address: "Adresse",
	more_info: "Plus d'informations",
	click_to_expand: "Cliquez pour agrandir",
	skip: "Sauter",
	signup: "S'inscrire",
	loading: "Chargement...",
	cookie_policy: "Politique relative aux cookies",
	privacy_policy: "Politique de confidentialité",
	warning: "Avertissement",
	error: "Erreur",
	no_results: "Aucun résultat trouvé.",
	read_more: "En savoir plus",
	recaptcha: "Protégé par reCAPTCHA",
	captcha: {
		"error_generic": "Impossible de vérifier le captcha. Veuillez recharger la page et réessayer.",
		"error_threshold": "Il semble que tu n'es pas un humain. S'il vous plait attendez quelques minutes et réessayez."
	},
	feed_not_available: "Flux non disponible",
	no_elements_found: "Aucun élément trouvé",
	previous_page: "Précédent",
	next_page: "Suivant",
	docenti: "Enseignants",
	yearly: "Annuel",
	monthly: "Mensuel",
	share_on: "Partager sur",
	show_more: "Montre plus...",
	show_less: "Montrer moins",
	share_with_friend: "Partager avec un ami",
	copy_link: "Copier le lien",
	copied: "Copié",
	generic_error: "Une erreur s'est produite lors du chargement de cette zone.",
	elapsed_time: {
		"seconds_one": "Il y a 1 seconde",
		"seconds_other": "{{count}} il y a une seconde",
		"minutes_one": "il y a 1 minute",
		"minutes_other": "Il y a {{count}} minutes",
		"hours_one": "Il y a 1 heure",
		"hours_other": "Il y a {{count}} heures",
		"days_one": "il y a 1 jour",
		"days_other": "Il y a {{count}} jours",
		"months_one": "Il y a 1 mois",
		"months_other": "Il y a {{count}} mois",
		"years_one": "il y a 1 an",
		"years_other": "Il y a {{count}} ans"
	},
	video: {
		"next": "Suivant",
		"prev": "Précédent",
		"no_videos_found": "Aucune vidéo trouvée",
		"watch_on_yt": "Voir sur YouTube",
		"cookie_consent": "Vous devez accepter les cookies pour regarder cette vidéo",
		"watch_video": "Voir la vidéo",
		"muted_notice": "Le son est coupé — cliquez pour l'activer",
		"unmute": "Activer le son"
	},
	reviews: {
		"title": "Commentaires",
		"filterLabels": {
			"province": "Province",
			"sortBy": "Trier par",
			"rating": "Vote",
			"course": "Cours",
			"product": "Produit",
			"lang": "Langue"
		},
		"bad": "Mauvais",
		"poor": "Pauvre",
		"average": "Moyenne",
		"great": "Très bon",
		"excellent": "Excellent",
		"verified_by_trustpilot": "Basé sur {{count}} avis vérifiés sur Trustpilot",
		"read_more": "En savoir plus",
		"read_less": "Lire moins",
		"review_date": "Examen de la {{date}}",
		"average_out_of": "{{average}} sur {{max}}",
		"statistics_label_one": "1 étoile",
		"statistics_label_other": "Étoiles {{count}}",
		"empty_set": "Pas de commentaire"
	},
	filters: {
		"sort_by": "Trier par",
		"filter": "Filtre"
	},
	courses: {
		"next_live": "En direct",
		"at_time": "Heures",
		"promo_label": "{{perc}}% de réduction",
		"free_signup": "S'inscrire gratuitement",
		"course_signup": "S'inscrire au cours",
		"free": "Gratuit",
		"buy_for_price": "Acheter à {{price}} {{symbol}}",
		"no_course_found": "Aucun cours trouvé",
		"signin": "Accéder au cours",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 heure",
		"duration_hours_other": "{{count}} heures",
		"total_duration": "{{duration}} totaux",
		"instead_of": "au lieu de",
		"promo_expires_on": "L'offre expire le {{date}}",
		"lessons": {
			"session_n": "Numéro de session {{sortOrder}}",
			"start_at": ", heures",
			"teachers_one": "Enseignant : {{names}}",
			"teachers_other": "Enseignants : {{names}}",
			"uploaded_at": "Date de chargement : {{date}}",
			"other_content": "Autre contenu"
		},
		"course_code": "Code du cours : {{code}}",
		"live_on": "En direct sur {{date}}",
		"live_from_to": "En ligne directement de {{from}} à {{to}}",
		"cfp_ack": "Remerciements {{count}} PCP",
		"cfp_deadline": "Date limite d'envoi de l'appel à propositions {{date}}",
		"reviews_avg": "Moyenne des votes {{average}} sur {{total}}",
		"reviews_count_one": "1 Évaluation",
		"reviews_count_other": "{{count}} notations",
		"sinf_approval": "Approbation du SINF",
		"cnappc_approval": "Approbation du CNAPPC",
		"filter": "Filtres",
		"lessons_count_one": "1 leçon",
		"lessons_count_other": "{{count}} leçons",
		"lessons_duration_one": "1 leçon de {{timePerLesson}} + {{timePerTest}} de test",
		"lessons_duration_other": "{{count}} leçons de {{timePerLesson}} + {{timePerTest}} de test",
		"lessons_duration_no_test_one": "1 leçon de {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} leçons de {{timePerLesson}}",
		"single_course": "Cours unique",
		"add_vat": "+ TVA",
		"vat_included": "TVA incluse",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Aucun élément trouvé" },
	pagination: { "next": "Page suivante" },
	search: {
		"clear": "Réinitialiser la recherche",
		"placeholder": "Recherche"
	},
	currency: { "label": "Monnaie" },
	alerts: {
		"confirm_consultancy": {
			"title": "Demande envoyée",
			"message": "Nous avons bien reçu votre demande de consultation. Le professionnel vous recontactera sous peu."
		},
		"consultancy_confirmed": {
			"title": "Consultation confirmée",
			"message": "Votre paiement a été reçu et votre consultation est confirmée."
		},
		"login_success": {
			"title": "Bon retour",
			"message": "Vous êtes maintenant connecté."
		},
		"login_error": {
			"title": "Échec de la connexion",
			"message": "Quelque chose s'est mal passé. Veuillez réessayer."
		},
		"logout_success": {
			"title": "Déconnecté",
			"message": "Vous avez été déconnecté."
		}
	}
};
var languages_default$7 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$6 = {
	download: { "wait_download": "<0>A letöltés másodperceken belül elindul. Ha mégsem indul el, <1>kattints ide</1> a fájl letöltéséhez.</0>" },
	form: {
		"required": "Ez a mező kötelező",
		"minLength": "Írj be legalább {{num}} karaktert",
		"maxLength": "A maximális karakterhossz {{num}}",
		"pattern": "Érvénytelen érték",
		"min": "Minimális érték: {{num}}",
		"max": "Maximális érték: {{num}}",
		"add_file": "Fájl hozzáadása",
		"too_many_files": "Túl sok fájl",
		"too_few_files": "Túl kevés fájl",
		"file_too_big": "A kiválasztott fájl túl nagy",
		"invalid_file": "A kiválasztott fájl érvénytelen",
		"max_files": "Fájlok maximális száma",
		"min_files": "Fájlok minimális száma",
		"types_allowed": "Engedélyezett fájlok",
		"max_weight": "Maximális fájl méret",
		"submit_file_is_uploading": "Meg kell várnod a fájl feltöltését ahhoz, hogy elmenthesd az űrlapot.",
		"upload_error": "Valamilyen hiba történt a fájl feltöltése során. Kérlek próbáld meg később.",
		"submit_validation_error": "Valamilyen hiba történt az űrlap mentése közben. Kérlek ellenőrizd az adatokat és próbáld meg később.",
		"submit_error": "Valamilyen hiba történt az űrlap mentése közben. Ha a probléma állandósul, kérlek lépj velünk kapcsolatba.",
		"privacy": "Elolvastam és egyetértek az <1><0>adatvédelmi irányelvekkel</0></1>",
		"terms": "Elolvastam és elfogadom az <1>általános szerződési feltételeket</1>",
		"login_prefill": "<0>Lépj be</0>, hogy automatikusan kitöltődjön az űrlap a saját adataiddal.",
		"signup_suggestion": "<0>Regisztrálj be</0>, hogy előre kitöltsük az adataidat az űr",
		"captcha_not_resolved": "Meg kell bizonyosodnunk róla az űrlap elküldése előtt, hogy valódi ember vagy-e",
		"captcha_not_ready": "A captcha még nem áll készen. Töltse be újra az oldalt, és próbálja újra.",
		"invalid_phone_prefix": "Érvénytelen előtag",
		"invalid_email": "Érvénytelen e-mail cím",
		"select": {
			"create": "{userInput}",
			"loading": "Betöltés...",
			"no_options": "Nem található opciók"
		},
		"invalid_phone": "A telefonszám érvénytelen",
		"doesnt_match": "A beillesztett értékek nem felelnek meg",
		"meeting": {
			"duration": "Időtartam: {{duration}}",
			"duration_label": "Időtartam",
			"duration_minutes": "{{minutes}} perc",
			"loading": "Elérhetőség betöltése…",
			"empty": "Jelenleg nincs elérhető időpont.",
			"no_slots": "A kiválasztott dátumhoz nincs elérhető időpont.",
			"back": "Vissza a naptárhoz",
			"change": "Dátum/időpont módosítása",
			"timezone": "Időzóna: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Hétfő",
					"short": "H"
				},
				"tuesday": {
					"long": "Kedd",
					"short": "K"
				},
				"wednesday": {
					"long": "Szerda",
					"short": "Sze"
				},
				"thursday": {
					"long": "Csütörtök",
					"short": "Cs"
				},
				"friday": {
					"long": "Péntek",
					"short": "P"
				},
				"saturday": {
					"long": "Szombat",
					"short": "Szo"
				},
				"sunday": {
					"long": "Vasárnap",
					"short": "V"
				}
			}
		},
		"slots": {
			"add": "Időpont hozzáadása",
			"remove": "Eltávolítás",
			"timezone": "Időzóna: {{timezone}}",
			"min": "Adjon meg legalább {{num}} időpontot.",
			"max": "Legfeljebb {{num}} időpontot adhat meg.",
			"item": "{{number}}. időpont"
		}
	},
	pricing: {
		"recommended": "Ajánlott",
		"discounted_to": "Promóció vége {{date}}",
		"per_month": "hónap",
		"per_year": "év",
		"free": "INGYENES",
		"badge_new": "új",
		"price_not_available": "Az ár ideiglenesen nem elérhető",
		"btn_buy_now": "Vedd meg most!",
		"badge_video": "videó",
		"incremental_version": "Minden, amit a {{prevProductName}} és még több:",
		"prices_starting_from": "Árak -tól",
		"per_workstation_zero": "munkaállomásonként",
		"per_workstation_one": "munkaállomásonként",
		"per_workstation_other": "munkaállomásonként (minimum {{count}})",
		"license_duration_months_one": "1 hónap",
		"license_duration_months_other": "{{count}} hónapok",
		"license_duration": "Licenc időtartama",
		"license_duration_infinite": "Örökös licenc",
		"license_already_active": "Aktív",
		"license_already_active_until": "Előfizetés {{date}}-ig",
		"vat": "HÉA"
	},
	yes: "igen",
	no: "nem",
	next: "Következő",
	back: "Vissza",
	language: "Nyelv",
	preferences: "Preferenciák",
	go_back: "Vissza",
	open: "Megnyitás",
	close: "Bezárás",
	login: "Bejelentkezés",
	no_video_found: "Nem található videó.",
	watch_playlist_on_youtube: "Nézd meg a teljes lejátszási listát a YouTube-on",
	search_video: "Videó keresése",
	logout: "Kijelentkezés",
	admin_panel: "Admin panel",
	my_products: "Saját termékeim",
	profile: "Profil",
	starting_from: "Kezdve",
	address: "Cím",
	more_info: "További információk",
	click_to_expand: "Kattints a lenyitáshoz",
	skip: "Kihagyás",
	signup: "Regisztráció",
	loading: "Betöltés...",
	cookie_policy: "Cookie szabályzat",
	privacy_policy: "Adatvédelmi irányelvek",
	warning: "Figyelem",
	error: "Hiba",
	no_results: "Nincs találat.",
	read_more: "Bővebben",
	recaptcha: "ReCAPTCHA védi",
	captcha: {
		"error_generic": "A captcha nem ellenőrizhető. Kérjük, töltse be újra az oldalt, és próbálja újra.",
		"error_threshold": "Úgy tűnik, nem vagy ember. Kérjük, várjon néhány percet, és próbálja újra."
	},
	feed_not_available: "A hírcsatorna nem elérhető",
	no_elements_found: "Nem található elemek",
	previous_page: "Előző",
	next_page: "Következő",
	docenti: "Tanárok",
	yearly: "Évi",
	monthly: "Havi",
	share_on: "Oszd meg",
	show_more: "Mutass többet...",
	show_less: "Mutass kevesebbet",
	share_with_friend: "Megosztás egy baráttal",
	copy_link: "Link másolása",
	copied: "Másolva",
	generic_error: "Hiba történt a terület betöltése közben.",
	elapsed_time: {
		"seconds_one": "1 másodperccel ezelőtt",
		"seconds_other": "{{count}} másodpercekkel ezelőtt",
		"minutes_one": "1 perccel ezelőtt",
		"minutes_other": "{{count}} percekkel ezelőtt",
		"hours_one": "1 órával ezelőtt",
		"hours_other": "{{count}} órákkal ezelőtt",
		"days_one": "1 nappal ezelőtt",
		"days_other": "{{count}} napokkal ezelőtt",
		"months_one": "1 hónappal ezelőtt",
		"months_other": "{{count}} hónapokkal ezelőtt",
		"years_one": "1 évvel ezelőtt",
		"years_other": "{{count}} évekkel ezelőtt"
	},
	video: {
		"next": "Következő",
		"prev": "Előző",
		"no_videos_found": "Nem találtunk videókat",
		"watch_on_yt": "Nézze meg a Youtube-on",
		"cookie_consent": "A videó megtekintéséhez el kell fogadnia a sütiket",
		"watch_video": "Videó megtekintése",
		"muted_notice": "A hang némítva van — kattintson a bekapcsoláshoz",
		"unmute": "Hang bekapcsolása"
	},
	reviews: {
		"title": "Vélemények",
		"filterLabels": {
			"province": "Állam",
			"sortBy": "Rendelés",
			"rating": "Rate",
			"course": "Tanfolyam",
			"product": "Termék",
			"lang": "Nyelv"
		},
		"bad": "Bad",
		"poor": "Szegény",
		"average": "Átlagos",
		"great": "Nagyszerű",
		"excellent": "Kiváló",
		"verified_by_trustpilot": "{{count}} ellenőrzött értékelések alapján a Trustpiloton",
		"read_more": "Bővebben",
		"read_less": "További információ",
		"review_date": "A {{date}} áttekintése",
		"average_out_of": "{{average}} az {{max}}",
		"statistics_label_one": "1 csillag",
		"statistics_label_other": "{{count}} csillagok",
		"empty_set": "Nincs vélemény"
	},
	filters: {
		"sort_by": "Rendezés",
		"filter": "Szűrő"
	},
	courses: {
		"next_live": "Élő",
		"at_time": "a  címen.",
		"promo_label": "{{perc}}% kedvezmény",
		"free_signup": "Regisztráljon ingyenesen",
		"course_signup": "Jelentkezzen a tanfolyamra",
		"free": "Ingyenes",
		"buy_for_price": "Vásárolja meg {{price}} {{symbol}}",
		"no_course_found": "Nem találtunk tanfolyamot",
		"signin": "Bejelentkezés",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 óra",
		"duration_hours_other": "{{count}} órák",
		"total_duration": "{{duration}} összesen",
		"instead_of": "ahelyett, hogy",
		"promo_expires_on": "A promóció {{date}}",
		"lessons": {
			"session_n": "Session n. {{sortOrder}}",
			"start_at": ", órák",
			"teachers_one": "Oktató: {{names}}",
			"teachers_other": "Oktatók: {{names}}",
			"uploaded_at": "Feltöltés dátuma: {{date}}",
			"other_content": "További tartalom"
		},
		"course_code": "Tanfolyam kódja: {{code}}",
		"live_on": "Élő online {{date}}",
		"live_from_to": "Élő online {{from}}-től {{to}}-ig}",
		"cfp_ack": "Díjak {{count}} kreditek",
		"cfp_deadline": "CFP határidő {{date}}",
		"reviews_avg": "Vélemények átlaga {{average}} a {{total}}",
		"reviews_count_one": "1 értékelés",
		"reviews_count_other": "{{count}} értékelések",
		"sinf_approval": "SINF jóváhagyás",
		"cnappc_approval": "CNAPPC jóváhagyás",
		"filter": "Szűrők",
		"lessons_count_one": "1 lecke",
		"lessons_count_other": "{{count}} leckék",
		"lessons_duration_one": "1 lecke {{timePerLesson}} + {{timePerTest}} teszt",
		"lessons_duration_other": "{{count}} leckék {{timePerLesson}} + {{timePerTest}} teszt",
		"lessons_duration_no_test_one": "1 lecke {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} leckék {{timePerLesson}}",
		"single_course": "Egyetlen kurzus",
		"add_vat": "+ HÉA",
		"vat_included": "Tartalmazza az ÁFA értékét",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Nincs talált tétel" },
	pagination: { "next": "Következő" },
	search: {
		"clear": "Tiszta keresés",
		"placeholder": "Keresés"
	},
	currency: { "label": "Pénznem" },
	alerts: {
		"confirm_consultancy": {
			"title": "Kérés elküldve",
			"message": "Megkaptuk a tanácsadási kérelmét. A szakember hamarosan felveszi Önnel a kapcsolatot."
		},
		"consultancy_confirmed": {
			"title": "Konzultáció megerősítve",
			"message": "Megkaptuk a fizetését, és a konzultációja megerősítést nyert."
		},
		"login_success": {
			"title": "Üdvözlünk újra",
			"message": "Sikeresen bejelentkeztél."
		},
		"login_error": {
			"title": "A bejelentkezés nem sikerült",
			"message": "Valamilye probléma történt. Kérlek próbáld újra később!"
		},
		"logout_success": {
			"title": "Kijelentkeztél",
			"message": "Sikeresen kijelentkeztél."
		}
	}
};
var languages_default$6 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$5 = {
	download: { "wait_download": "<0>Il download dovrebbe partire a momenti. Se non partisse automaticamente, <1>clicca qui</1> per scaricare il file.</0>" },
	form: {
		"required": "Questo campo è obbligatorio",
		"minLength": "Inserisci almeno {{num}} caratteri",
		"maxLength": "Inserisci al massimo {{num}} caratteri",
		"pattern": "Il valore inserito non è valido",
		"min": "Inserisci un valore superiore a {{num}}",
		"max": "Inserisci un valore inferiore a {{num}}",
		"add_file": "Sfoglia",
		"too_many_files": "Hai selezionato troppi file",
		"too_few_files": "Hai selezionato troppi pochi file",
		"file_too_big": "Il file selezionato è troppo grande",
		"invalid_file": "Il file selezionato non è valido",
		"max_files": "Numero massimo di file",
		"min_files": "Numero minimo di file",
		"types_allowed": "File permessi",
		"max_weight": "Dimensione massima file",
		"submit_file_is_uploading": "Devi attendere che l'upload dei file sia terminato prima di procedere all'invio della form",
		"upload_error": "Si è verificato un errore durante l'upload del file. Ti preghiamo di riprovare.",
		"submit_validation_error": "Si è verificato un errore durante l'invio della form. Ti preghiamo di controllare i dati inseriti e riprovare.",
		"submit_error": "Si è verificato un errore durante l'invio della form. Ti preghiamo di contattarci se il problema persiste.",
		"privacy": "Ho letto e accettato la <1><0>Privacy Policy</0></1>",
		"terms": "Ho letto e accettato i <1>termini e condizioni</1>.",
		"login_prefill": "<0>Effettua l'accesso</0> per riempire automaticamente i campi con i tuoi dati.",
		"signup_suggestion": "<0>Registrati ora</0> per compilare automaticamente i campi delle nostre form!",
		"captcha_not_resolved": "Per procedere all'invio della form, è necessario verificare di essere umano.",
		"captcha_not_ready": "Il captcha non è pronto. Ricarica la pagina e riprova.",
		"invalid_phone_prefix": "Prefisso non valido",
		"invalid_email": "Indirizzo email non valido",
		"select": {
			"create": "{userInput}",
			"loading": "Caricamento...",
			"no_options": "Nessun opzione trovata"
		},
		"invalid_phone": "Il numero di telefono non è valido",
		"doesnt_match": "Il valori inseriti non coincidono",
		"meeting": {
			"duration": "Durata: {{duration}}",
			"duration_label": "Durata",
			"duration_minutes": "{{minutes}} min",
			"loading": "Caricamento disponibilità…",
			"empty": "Nessuna disponibilità al momento.",
			"no_slots": "Non ci sono orari disponibili per la data selezionata.",
			"back": "Torna al calendario",
			"change": "Cambia data/ora",
			"timezone": "Fuso orario: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Lunedì",
					"short": "Lun"
				},
				"tuesday": {
					"long": "Martedì",
					"short": "Mar"
				},
				"wednesday": {
					"long": "Mercoledì",
					"short": "Mer"
				},
				"thursday": {
					"long": "Giovedì",
					"short": "Gio"
				},
				"friday": {
					"long": "Venerdì",
					"short": "Ven"
				},
				"saturday": {
					"long": "Sabato",
					"short": "Sab"
				},
				"sunday": {
					"long": "Domenica",
					"short": "Dom"
				}
			}
		},
		"slots": {
			"add": "Aggiungi disponibilità",
			"remove": "Rimuovi",
			"timezone": "Fuso orario: {{timezone}}",
			"min": "Indica almeno {{num}} disponibilità.",
			"max": "Puoi indicare al massimo {{num}} disponibilità.",
			"item": "Disponibilità {{number}}"
		}
	},
	pricing: {
		"recommended": "Consigliato",
		"discounted_to": "Offerta valida fino al {{date}}",
		"per_month": "mese",
		"per_year": "anno",
		"free": "GRATIS",
		"badge_new": "new",
		"price_not_available": "Prezzo momentaneamente non disponibile",
		"btn_buy_now": "Acquista",
		"badge_video": "video",
		"incremental_version": "Tutto quello offerto con {{prevProductName}} e in più:",
		"prices_starting_from": "Prezzi a partire da",
		"per_workstation_zero": "a postazione",
		"per_workstation_one": "a postazione",
		"per_workstation_other": "a postazione (minimo {{count}})",
		"license_duration_months_one": "1 mese",
		"license_duration_months_other": "{{count}} mesi",
		"license_duration": "Durata licenza",
		"license_duration_infinite": "Licenza perpetua",
		"license_already_active": "Attivo",
		"license_already_active_until": "Abbonato fino al {{date}}",
		"vat": "IVA"
	},
	yes: "si",
	no: "no",
	next: "Avanti",
	back: "Indietro",
	language: "Lingua",
	preferences: "Preferenze",
	go_back: "Torna indietro",
	open: "Apri",
	close: "Chiudi",
	login: "Accedi",
	no_video_found: "Nessun video trovato.",
	watch_playlist_on_youtube: "Guarda tutti i video su YouTube",
	search_video: "Ricerca video",
	logout: "Esci",
	admin_panel: "Pannello admin",
	my_products: "I miei prodotti",
	profile: "Profilo",
	starting_from: "A partire da",
	address: "Indirizzo",
	more_info: "Maggiori informazioni",
	click_to_expand: "Clicca per espandere",
	skip: "Salta",
	signup: "Registrati",
	loading: "Caricamento...",
	cookie_policy: "Cookie policy",
	privacy_policy: "Privacy policy",
	warning: "Attenzione",
	error: "Errore",
	no_results: "Nessun risultato trovato.",
	read_more: "Leggi di più",
	recaptcha: "Protetto da reCAPTCHA",
	captcha: {
		"error_generic": "Impossibile verificare il captcha. Ti preghiamo di ricaricare la pagina e riprovare.",
		"error_threshold": "Sembrerebbe che tu non sia umano. Ti preghiamo di attendere qualche minuto e riprovare."
	},
	feed_not_available: "Nessuna news disponibile",
	no_elements_found: "Nessun elemento trovato",
	previous_page: "Precedente",
	next_page: "Successivo",
	docenti: "Docenti",
	yearly: "Annuale",
	monthly: "Mensile",
	share_on: "Condividi con",
	show_more: "Mostra di più...",
	show_less: "Mostra meno",
	share_with_friend: "Condividi con un amico",
	copy_link: "Copia link",
	copied: "Copiato",
	generic_error: "Si è verificato un errore durante il caricamento di quest'area.",
	elapsed_time: {
		"seconds_one": "1 secondo fa",
		"seconds_other": "{{count}} secondo fa",
		"minutes_one": "1 minuto fa",
		"minutes_other": "{{count}} minuti fa",
		"hours_one": "1 ora fa",
		"hours_other": "{{count}} ore fa",
		"days_one": "1 giorno fa",
		"days_other": "{{count}} giorni fa",
		"months_one": "1 mese fa",
		"months_other": "{{count}} mesi fa",
		"years_one": "1 anno fa",
		"years_other": "{{count}} anni fa"
	},
	video: {
		"next": "Prossimo",
		"prev": "Precedente",
		"no_videos_found": "Nessun video trovato",
		"watch_on_yt": "Guarda su YouTube",
		"cookie_consent": "Per guardare questo video è necessario accettare i cookie",
		"watch_video": "Guarda il video",
		"muted_notice": "L'audio è disattivato — clicca per attivarlo",
		"unmute": "Attiva l'audio"
	},
	reviews: {
		"title": "Recensioni",
		"filterLabels": {
			"province": "Provincia",
			"sortBy": "Ordina per",
			"rating": "Voto",
			"course": "Corso",
			"product": "Prodotto",
			"lang": "Lingua"
		},
		"bad": "Cattivo",
		"poor": "Povero",
		"average": "Nella media",
		"great": "Molto buono",
		"excellent": "Eccellente",
		"verified_by_trustpilot": "Sulla base di {{count}} recensioni verificate su Trustpilot",
		"read_more": "Leggi di più",
		"read_less": "Leggi di meno",
		"review_date": "Recensione del {{date}}",
		"average_out_of": "{{average}} su {{max}}",
		"statistics_label_one": "1 stella",
		"statistics_label_other": "{{count}} stelle",
		"empty_set": "Nessuna recensione"
	},
	filters: {
		"sort_by": "Ordina per",
		"filter": "Filtra"
	},
	courses: {
		"next_live": "Live",
		"at_time": "ore",
		"promo_label": "{{perc}}% di sconto",
		"free_signup": "Iscriviti gratis",
		"course_signup": "Iscriviti al corso",
		"free": "Gratis",
		"buy_for_price": "Acquista a {{price}} {{symbol}}",
		"no_course_found": "Nessun corso trovato",
		"signin": "Accedi al corso",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 ora",
		"duration_hours_other": "{{count}} ore",
		"total_duration": "{{duration}} totali",
		"instead_of": "anziché",
		"promo_expires_on": "L'offerta scade il {{date}}",
		"lessons": {
			"session_n": "Sessione n. {{sortOrder}}",
			"start_at": ", ore",
			"teachers_one": "Docente: {{names}}",
			"teachers_other": "Docenti: {{names}}",
			"uploaded_at": "Data di caricamento: {{date}}",
			"other_content": "Altro contenuto",
			"blocked_watch_files_webinar": "Il materiale didattico viene reso disponibile solo dopo aver visionato la lezione in diretta.",
			"blocked_watch_files_video": "Il materiale didattico viene reso disponibile solo dopo aver visionato la lezione in differita.",
			"blocked_watch_quiz_webinar": "Il test viene reso disponibile solo dopo aver visionato la lezione in diretta.",
			"blocked_watch_quiz_video": "Il test viene reso disponibile solo dopo aver visionato la lezione in differita.",
			"blocked_sequential_lesson_webinar": "Il webinar delle lezioni viene reso disponibile solo dopo aver superato il test delle lezioni precedenti.",
			"blocked_sequential_lesson_video": "Il video delle lezioni viene reso disponibile solo dopo aver superato il test delle lezioni precedenti.",
			"blocked_sequential_files": "Il materiale didattico delle lezioni viene reso disponibile solo dopo aver superato il test delle lezioni precedenti.",
			"blocked_sequential_quiz": "Il test delle lezioni viene reso disponibile solo dopo aver superato il test delle lezioni precedenti.",
			"empty_video": "Nessun video disponibile per questa lezione.",
			"empty_materials": "Nessun materiale didattico per questa lezione.",
			"open_external": "Apri il contenuto esterno",
			"open_lesson": "Apri lezione",
			"back_to_course": "Torna al corso",
			"download_material": "Clicca qui per scaricare il materiale",
			"preview_disclaimer_office": "L'anteprima potrebbe differire dal contenuto effettivo, consigliamo di scaricare il file.",
			"preview_error": "Anteprima non disponibile. Scarica il file per visualizzarlo.",
			"preview_loading": "Caricamento anteprima…"
		},
		"course_code": "Codice corso: {{code}}",
		"live_on": "Diretta online il {{date}}",
		"live_from_to": "Diretta online dal {{from}} al {{to}}",
		"cfp_ack": "Riconosce {{count}} CFP",
		"cfp_deadline": "Termine per i CFP {{date}}",
		"reviews_avg": "Media voti {{average}} su {{total}}",
		"reviews_count_one": "1 valutazione",
		"reviews_count_other": "{{count}} valutazioni",
		"sinf_approval": "approvazione SINF",
		"cnappc_approval": "approvazione CNAPPC",
		"filter": "Filtri",
		"lessons_count_one": "1 lezione",
		"lessons_count_other": "{{count}} lezioni",
		"lessons_duration_one": "1 lezione da {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lezioni da {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 lezione da {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lezioni da {{timePerLesson}}",
		"single_course": "Singolo corso",
		"add_vat": "+ IVA",
		"vat_included": "IVA inclusa",
		"card_credits_uploaded": "CFP Caricati il {{date}}",
		"card_credits_pending_with_count": "I {{count}} CFP verranno caricati in {{date}}",
		"card_credits_pending_generic": "I CFP verranno caricati in {{date}}",
		"card_competence_note": " (ma sempre con competenza {{year}})",
		"trial_request_button": "Richiedi attivazione",
		"trial_waiting_button": "Richiesta in corso",
		"trial_waiting_hint": "In attesa del completamento dell'ordine: torna qui dopo averlo concluso, o riprova più tardi.",
		"trial_requested_button": "Richiesta inviata",
		"trial_requested_hint": "La richiesta è in fase di elaborazione. Riceverai una comunicazione non appena la tua licenza verrà emessa.",
		"trial_licensed_button": "Licenza già attiva",
		"trial_duration_one": "{{count}} mese",
		"trial_duration_other": "{{count}} mesi",
		"trial_duration_course": "Per la durata del corso",
		"trial_banner_requested_title": "Richiesta inviata",
		"trial_banner_requested_body": "Abbiamo registrato il tuo ordine. La licenza temporanea sarà disponibile a breve e resterà valida per la durata indicata.",
		"trial_banner_already_title": "Richiesta già registrata",
		"trial_banner_already_body": "Questa richiesta risulta già inviata: non devi fare altro.",
		"trial_banner_expired_title": "Sessione scaduta",
		"trial_banner_expired_body": "Il checkout è scaduto prima del completamento: attendi qualche minuto e riprova.",
		"trial_licensed_trial_until": "Versione di prova attiva e valida fino al {{date}}.",
		"trial_licensed_trial_perpetual": "Versione di prova attiva senza scadenza.",
		"trial_licensed_other_until": "Risulta che hai già la licenza attiva di {{product}} fino al {{date}}.",
		"trial_licensed_other_perpetual": "Risulta che hai già la licenza attiva di {{product}} (senza scadenza).",
		"trial_requested_expired_button": "Licenza già richiesta",
		"trial_requested_expired_body": "La versione di prova è già stata richiesta in passato ed è scaduta il {{date}}."
	},
	feed: { "no_items_found": "Nessun elemento trovato" },
	pagination: { "next": "Pagina successiva" },
	data_table: {
		"sort_ascending": "Ordina per {{column}}, crescente",
		"sort_descending": "Ordina per {{column}}, decrescente",
		"sort_clear": "Rimuovi l'ordinamento per {{column}}"
	},
	search: {
		"clear": "Reset ricerca",
		"placeholder": "Cerca"
	},
	currency: { "label": "Valuta" },
	consultancies: {
		"book_from_price": "Prenota da {{price}} {{symbol}}/ora",
		"view_profile": "Vedi il profilo",
		"curriculum": "Curriculum",
		"no_consultant_found": "Nessun consulente trovato",
		"hourly_rate": "Tariffa oraria: {{price}} {{symbol}}",
		"add_vat": "+ IVA",
		"booking_unavailable": "Le prenotazioni per questo consulente non sono al momento disponibili.",
		"requests_empty": "Non hai ancora ricevuto richieste di consulenza.",
		"requests_hours": "Ore",
		"requests_anonymous": "Cliente senza account",
		"requests_filter_all": "Tutte",
		"requests_filter_to_confirm": "Da confermare",
		"requests_filter_confirmed": "Confermate",
		"requests_filter_archived": "Archiviate",
		"requests_status_pending": "In attesa di conferma",
		"requests_status_scheduled": "In attesa di pagamento",
		"requests_status_paid": "Pagata",
		"requests_status_completed": "Conclusa",
		"requests_status_rejected": "Rifiutata",
		"requests_status_expired": "Scaduta",
		"requests_proposed_slots": "Disponibilità proposte",
		"requests_scheduled_at": "Appuntamento",
		"requests_created_at": "Richiesta inviata",
		"requests_price": "Prezzo",
		"requests_deadline": "Scadenza",
		"requests_paid_at": "Pagata il",
		"requests_rejected_at": "Rifiutata il",
		"requests_expired_at": "Scaduta il",
		"requests_payment_link": "Link di pagamento",
		"requests_copy_payment_link": "Copia link di pagamento",
		"requests_copied": "Copiato",
		"requests_confirm": "Conferma",
		"requests_reconfirm": "Riconferma",
		"requests_reject": "Conferma rimozione",
		"requests_reject_action": "Rifiuta",
		"requests_confirm_title": "Conferma consulenza",
		"requests_confirm_datetime": "Data e ora concordate",
		"requests_confirm_hours": "Ore",
		"requests_confirm_submit": "Invia richiesta di pagamento",
		"requests_cancel": "Annulla",
		"requests_confirm_success": "La richiesta di pagamento è stata inviata.",
		"requests_reject_success": "La richiesta di consulenza è stata rifiutata.",
		"requests_reject_confirm": "Confermi di voler rifiutare questa richiesta di consulenza?",
		"requests_datetime_invalid": "Scegli una data e un orario futuri validi.",
		"requests_hours_invalid": "Inserisci un numero intero positivo di ore.",
		"requests_action_error": "Non è stato possibile completare la richiesta. Riprova.",
		"requests_booker": "Richiedente",
		"requests_detail": "Richiesta",
		"requests_status": "Stato",
		"requests_actions": "Azioni",
		"requests_table_caption": "Richieste di consulenza ricevute",
		"requests_tab_all": "Tutte",
		"requests_tab_to_confirm": "Da confermare",
		"requests_tab_scheduled": "In programma",
		"requests_tab_completed": "Concluse",
		"requests_tab_archived": "Rifiutate e scadute",
		"requests_datetime": "Data / Ora",
		"requests_customer": "Cliente",
		"requests_duration": "Durata",
		"requests_duration_one": "1 ora",
		"requests_duration_other": "{{count}} ore",
		"requests_slots": "Orari proposti",
		"requests_view_all": "Vedi tutte ({{count}})",
		"requests_today": "Oggi",
		"requests_expires_relative": "scade {{relative}}",
		"requests_expires_days": "scade tra {{count}} giorni",
		"requests_expires_tomorrow": "scade domani",
		"requests_expires_hours": "scade tra {{count}} ore",
		"requests_expires_minutes": "scade tra {{count}} minuti",
		"requests_in_minutes": "tra {{count}} minuti",
		"requests_in_hours": "tra {{count}} ore",
		"requests_tomorrow": "domani",
		"requests_payment_pending": "Da pagare",
		"requests_start_video": "Avvia videochiamata",
		"requests_copy_payment": "Copia link pagamento",
		"requests_repropose": "Riproponi",
		"requests_compensi": "Vai al calcolo compensi"
	},
	alerts: {
		"confirm_consultancy": {
			"title": "Richiesta inviata",
			"message": "Abbiamo ricevuto la tua richiesta di consulenza. Il professionista ti ricontatterà a breve."
		},
		"consultancy_confirmed": {
			"title": "Consulenza confermata",
			"message": "Il pagamento è stato ricevuto e la tua consulenza è confermata."
		},
		"login_success": {
			"title": "Bentornato",
			"message": "Hai effettuato l'accesso."
		},
		"login_error": {
			"title": "Accesso non riuscito",
			"message": "Si è verificato un errore. Ti preghiamo di riprovare."
		},
		"logout_success": {
			"title": "Disconnessione effettuata",
			"message": "Hai effettuato la disconnessione."
		}
	}
};
var languages_default$5 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$4 = {
	download: { "wait_download": "<0>O download deve começar em alguns segundos. Se não iniciar automaticamente, <1>clique aqui</1> para baixar o arquivo.</0>" },
	form: {
		"required": "Este campo é obrigatório",
		"minLength": "Digite pelo menos {{num}} caracteres",
		"maxLength": "Máximo de {{num}} caracteres são permitidos",
		"pattern": "O valor não é válido",
		"min": "Valor mínimo permitido: {{num}}",
		"max": "Valor máximo permitido: {{num}}",
		"add_file": "Adicionar ficheiro",
		"too_many_files": "Muitos arquivos",
		"too_few_files": "Poucos arquivos",
		"file_too_big": "O arquivo selecionado é muito grande",
		"invalid_file": "O arquivo selecionado não é válido",
		"max_files": "Número máximo de arquivos",
		"min_files": "Número mínimo de arquivos",
		"types_allowed": "Arquivos permitidos",
		"max_weight": "Tamanho máximo do arquivo",
		"submit_file_is_uploading": "Precisa aguardar a conclusão do upload antes de enviar o seu formulário.",
		"upload_error": "Algo deu errado ao fazer o upload do seu arquivo. Por favor, tente novamente.",
		"submit_validation_error": "Algo deu errado ao enviar seu formulário. Por favor, verifique os seus dados e tente novamente.",
		"submit_error": "Algo deu errado ao enviar o seu formulário. Se o problema persistir, entre em contato conosco.",
		"privacy": "Li e concordei com a <1><0>Política de Privacidade</0></1>",
		"terms": "Li e concordei com os <1>termos e condições</1>",
		"login_prefill": "<0>Faça login</0> para preencher automaticamente as suas informações no formulário.",
		"signup_suggestion": "<0>Inscreva-se agora</0> para preencher previamente os seus dados em nossos formulários!",
		"captcha_not_resolved": "Você precisa confirmar que é humano antes de enviar seu formulário.",
		"captcha_not_ready": "O captcha não está pronto. Recarregue a página e tente novamente.",
		"invalid_phone_prefix": "Prefixo inválido",
		"invalid_email": "Endereço de email inválido",
		"select": {
			"create": "{userInput}",
			"loading": "Carregando...",
			"no_options": "Nenhuma opção encontrada"
		},
		"invalid_phone": "O número de telefone é inválido",
		"doesnt_match": "Os valores introduzidos não correspondem",
		"meeting": {
			"duration": "Duração: {{duration}}",
			"duration_label": "Duração",
			"duration_minutes": "{{minutes}} min",
			"loading": "A carregar disponibilidade…",
			"empty": "Sem disponibilidade de momento.",
			"no_slots": "Não há horários disponíveis para a data selecionada.",
			"back": "Voltar ao calendário",
			"change": "Alterar data/hora",
			"timezone": "Fuso horário: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Segunda-feira",
					"short": "Seg"
				},
				"tuesday": {
					"long": "Terça-feira",
					"short": "Ter"
				},
				"wednesday": {
					"long": "Quarta-feira",
					"short": "Qua"
				},
				"thursday": {
					"long": "Quinta-feira",
					"short": "Qui"
				},
				"friday": {
					"long": "Sexta-feira",
					"short": "Sex"
				},
				"saturday": {
					"long": "Sábado",
					"short": "Sáb"
				},
				"sunday": {
					"long": "Domingo",
					"short": "Dom"
				}
			}
		},
		"slots": {
			"add": "Adicionar disponibilidade",
			"remove": "Remover",
			"timezone": "Fuso horário: {{timezone}}",
			"min": "Indique pelo menos {{num}} disponibilidades.",
			"max": "Pode indicar no máximo {{num}} disponibilidades.",
			"item": "Disponibilidade {{number}}"
		}
	},
	pricing: {
		"recommended": "Recomendado",
		"discounted_to": "A promoção termina em {{date}}",
		"per_month": "Mês",
		"per_year": "Ano",
		"free": "GRÁTIS",
		"badge_new": "novo",
		"price_not_available": "Preço temporariamente indisponível",
		"btn_buy_now": "Compre agora",
		"badge_video": "video",
		"incremental_version": "Tudo o que é oferecido com {{prevProductName}} e muito mais:",
		"prices_starting_from": "Preços a partir de",
		"per_workstation_zero": "na estação",
		"per_workstation_one": "na estação",
		"per_workstation_other": "por publicação (mínimo {{count}})",
		"license_duration_months_one": "1 mês",
		"license_duration_months_other": "{{count}} meses",
		"license_duration": "Duração da licença",
		"license_duration_infinite": "Licença perpétua",
		"license_already_active": "Ativo",
		"license_already_active_until": "Assinante até {{date}}",
		"vat": "IVA"
	},
	yes: "sim",
	no: "não",
	next: "Próximo",
	back: "Voltar",
	language: "Idioma",
	preferences: "Preferências",
	go_back: "Volte atrás",
	open: "Abrir",
	close: "Fechar",
	login: "Registrar",
	no_video_found: "Nenhum vídeo encontrado.",
	watch_playlist_on_youtube: "Veja a playlist inteira no YouTube",
	search_video: "Procurar vídeo",
	logout: "Sair",
	admin_panel: "Painel de administração",
	my_products: "Os meus produtos",
	profile: "Perfil",
	starting_from: "A partir de",
	address: "Endereço",
	more_info: "Mais informações",
	click_to_expand: "Clique para expandir",
	skip: "Pular",
	signup: "Inscrever-se",
	loading: "Carregando...",
	cookie_policy: "Política de cookies",
	privacy_policy: "Política de Privacidade",
	warning: "Aviso",
	error: "Erro",
	no_results: "Nenhum resultado encontrado.",
	read_more: "Ler mais",
	recaptcha: "Protegido por reCAPTCHA",
	captcha: {
		"error_generic": "Não foi possível verificar o captcha. Por favor, recarregue a página e tente denovo.",
		"error_threshold": "Parece que você não é humano. Por favor, aguarde alguns minutos e tente novamente."
	},
	feed_not_available: "Feed não disponível",
	no_elements_found: "Nenhum elemento encontrado",
	previous_page: "Anterior",
	next_page: "Próximo",
	docenti: "Professores",
	yearly: "Anual",
	monthly: "Por mês",
	share_on: "Compartilhar no",
	show_more: "Mostre mais...",
	show_less: "Mostre menos",
	share_with_friend: "Partilhar com um amigo",
	copy_link: "Copiar ligação",
	copied: "Copiado",
	generic_error: "Ocorreu um erro ao carregar esta área.",
	elapsed_time: {
		"seconds_one": "1 segundo atrás",
		"seconds_other": "{{count}} segundo atrás",
		"minutes_one": "1 minuto atrás",
		"minutes_other": "{{count}} minutos atrás",
		"hours_one": "1 hora atrás",
		"hours_other": "{{count}} horas atrás",
		"days_one": "1 dia atrás",
		"days_other": "{{count}} dias atrás",
		"months_one": "1 mês atrás",
		"months_other": "{{count}} meses atrás",
		"years_one": "1 ano atrás",
		"years_other": "{{count}} anos atrás"
	},
	video: {
		"next": "Seguinte",
		"prev": "Anterior",
		"no_videos_found": "Nenhum vídeo encontrado",
		"watch_on_yt": "Ver no YouTube",
		"cookie_consent": "Para ver este vídeo é necessário aceitar os cookies",
		"watch_video": "Ver o vídeo",
		"muted_notice": "O áudio está sem som — clique para ativar",
		"unmute": "Ativar o som"
	},
	reviews: {
		"title": "Comentários",
		"filterLabels": {
			"province": "Província",
			"sortBy": "Ordenar por",
			"rating": "Votação",
			"course": "Curso",
			"product": "Produto",
			"lang": "Língua"
		},
		"bad": "Mau",
		"poor": "Pobres",
		"average": "Média",
		"great": "Muito bom",
		"excellent": "Excelente",
		"verified_by_trustpilot": "Baseado em {{count}} comentários verificados na Trustpilot",
		"read_more": "Ler mais",
		"read_less": "Ler menos",
		"review_date": "Revisão da {{date}}",
		"average_out_of": "{{average}} em {{max}}",
		"statistics_label_one": "1 estrela",
		"statistics_label_other": "{{count}} estrelas",
		"empty_set": "Nenhuma revisão"
	},
	filters: {
		"sort_by": "Ordenar por",
		"filter": "Filtro"
	},
	courses: {
		"next_live": "Em direto",
		"at_time": "Horas",
		"promo_label": "{{perc}}% de desconto",
		"free_signup": "Inscrever-se gratuitamente",
		"course_signup": "Inscrever-se no curso",
		"free": "Grátis",
		"buy_for_price": "Comprar a {{price}} {{symbol}}",
		"no_course_found": "Nenhum curso encontrado",
		"signin": "Aceder ao curso",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 hora",
		"duration_hours_other": "{{count}} horas",
		"total_duration": "{{duration}} totais",
		"instead_of": "em vez de",
		"promo_expires_on": "A oferta expira em {{date}}",
		"lessons": {
			"session_n": "Sessão n.º {{sortOrder}}",
			"start_at": ", horas",
			"teachers_one": "Professor: {{names}}",
			"teachers_other": "Professores: {{names}}",
			"uploaded_at": "Data de carregamento: {{date}}",
			"other_content": "Outro conteúdo"
		},
		"course_code": "Código do curso: {{code}}",
		"live_on": "Em direto online em {{date}}",
		"live_from_to": "Diretamente online de {{from}} para {{to}}",
		"cfp_ack": "Reconhece {{count}} PCP",
		"cfp_deadline": "Prazo final da PCP {{date}}",
		"reviews_avg": "Média de votos {{average}} em {{total}}",
		"reviews_count_one": "1 Avaliação",
		"reviews_count_other": "{{count}} classificações",
		"sinf_approval": "Aprovação do SINF",
		"cnappc_approval": "Aprovação do CNAPPC",
		"filter": "Filtros",
		"lessons_count_one": "1 lição",
		"lessons_count_other": "{{count}} lições",
		"lessons_duration_one": "1 lição de {{timePerLesson}} + {{timePerTest}} de teste",
		"lessons_duration_other": "{{count}} lições de {{timePerLesson}} + {{timePerTest}} de teste",
		"lessons_duration_no_test_one": "1 lição de {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lições de {{timePerLesson}}",
		"single_course": "Curso único",
		"add_vat": "+ IVA",
		"vat_included": "IVA incluido",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Nenhum item encontrado" },
	pagination: { "next": "Página seguinte" },
	search: {
		"clear": "Repor a pesquisa",
		"placeholder": "Pesquisar"
	},
	currency: { "label": "Moeda" },
	alerts: {
		"confirm_consultancy": {
			"title": "Pedido enviado",
			"message": "Recebemos o seu pedido de consultoria. O profissional entrará em contacto consigo em breve."
		},
		"consultancy_confirmed": {
			"title": "Consulta confirmada",
			"message": "Recebemos o seu pagamento e a sua consulta está confirmada."
		},
		"login_success": {
			"title": "Bem-vindo de volta",
			"message": "Sessão iniciada."
		},
		"login_error": {
			"title": "Falha no início de sessão",
			"message": "Algo deu errado. Por favor, tente novamente."
		},
		"logout_success": {
			"title": "Sessão terminada",
			"message": "A sua sessão foi terminada."
		}
	}
};
var languages_default$4 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$3 = {
	download: { "wait_download": "<0>Pobieranie powinno rozpocząć się za kilka sekund. Jeśli nie rozpocznie się automatycznie, <1>kliknij tutaj</1>, aby pobrać plik.</0>." },
	form: {
		"required": "To pole jest wymagane",
		"minLength": "Wpisz co najmniej {{num}} znaków",
		"maxLength": "Dozwolona jest maksymalna liczba znaków {{num}}",
		"pattern": "Wartość jest nieprawidłowa",
		"min": "Minimalna dozwolona wartość: {{num}}",
		"max": "Maksymalna dozwolona wartość: {{num}}",
		"add_file": "Dodaj plik",
		"too_many_files": "Zbyt wiele plików",
		"too_few_files": "Zbyt mało plików",
		"file_too_big": "Wybrany plik jest zbyt duży",
		"invalid_file": "Wybrany plik jest nieprawidłowy",
		"max_files": "Maksymalna liczba plików",
		"min_files": "Minimalna liczba plików",
		"types_allowed": "Dozwolone pliki",
		"max_weight": "Maksymalny rozmiar pliku",
		"submit_file_is_uploading": "Przed wysłaniem formularza należy poczekać na zakończenie przesyłania.",
		"upload_error": "Coś poszło nie tak podczas przesyłania pliku. Spróbuj ponownie.",
		"submit_validation_error": "Coś poszło nie tak podczas przesyłania formularza. Sprawdź swoje dane i spróbuj ponownie.",
		"submit_error": "Coś poszło nie tak podczas przesyłania formularza. Jeśli problem będzie się powtarzał, prosimy o kontakt.",
		"privacy": "Przeczytałem i akceptuję <1><0>Politykę prywatności</0></1>.",
		"terms": "Zapoznałem się i akceptuję <1>regulamin</1>.",
		"login_prefill": "<0>Login</0>, aby automatycznie wypełnić informacje w formularzu.",
		"signup_suggestion": "<0>Zarejestruj się teraz</0>, aby wstępnie wypełnić swoje dane w naszych formularzach!",
		"captcha_not_resolved": "Przed wysłaniem formularza musisz potwierdzić, że jesteś człowiekiem.",
		"captcha_not_ready": "Captcha nie jest gotowe. Przeładuj stronę i spróbuj ponownie.",
		"invalid_phone_prefix": "Prefiks jest nieprawidłowy",
		"invalid_email": "Nieprawidłowy adres e-mail",
		"select": {
			"create": "{userInput}",
			"loading": "Ładowanie...",
			"no_options": "Nie znaleziono żadnych opcji"
		},
		"invalid_phone": "Numer telefonu jest nieprawidłowy",
		"doesnt_match": "Wstawione wartości nie odpowiadają",
		"meeting": {
			"duration": "Czas trwania: {{duration}}",
			"duration_label": "Czas trwania",
			"duration_minutes": "{{minutes}} min",
			"loading": "Ładowanie dostępności…",
			"empty": "Brak dostępnych terminów.",
			"no_slots": "Brak dostępnych godzin dla wybranej daty.",
			"back": "Powrót do kalendarza",
			"change": "Zmień datę/godzinę",
			"timezone": "Strefa czasowa: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Poniedziałek",
					"short": "Pon"
				},
				"tuesday": {
					"long": "Wtorek",
					"short": "Wt"
				},
				"wednesday": {
					"long": "Środa",
					"short": "Śr"
				},
				"thursday": {
					"long": "Czwartek",
					"short": "Czw"
				},
				"friday": {
					"long": "Piątek",
					"short": "Pt"
				},
				"saturday": {
					"long": "Sobota",
					"short": "Sob"
				},
				"sunday": {
					"long": "Niedziela",
					"short": "Ndz"
				}
			}
		},
		"slots": {
			"add": "Dodaj dostępność",
			"remove": "Usuń",
			"timezone": "Strefa czasowa: {{timezone}}",
			"min": "Podaj co najmniej {{num}} terminów.",
			"max": "Możesz podać maksymalnie {{num}} terminów.",
			"item": "Dostępność {{number}}"
		}
	},
	pricing: {
		"recommended": "Zalecane",
		"discounted_to": "Promocja kończy się {{date}}",
		"per_month": "miesiąc",
		"per_year": "rok",
		"free": "BEZPŁATNY",
		"badge_new": "nowy",
		"price_not_available": "Cena tymczasowo niedostępna",
		"btn_buy_now": "Kup teraz",
		"badge_video": "wideo",
		"incremental_version": "Wszystko, co oferuje {{prevProductName}} i więcej:",
		"prices_starting_from": "Ceny zaczynają się od",
		"per_workstation_zero": "na stację roboczą",
		"per_workstation_one": "na stację roboczą",
		"per_workstation_other": "na stację roboczą (minimum {{count}})",
		"license_duration_months_few": "{{count}} miesiące",
		"license_duration_months_many": "{{count}} miesięcy",
		"license_duration_months_one": "1 miesiąc",
		"license_duration_months_other": "{{count}} miesięcy",
		"license_duration": "Okres obowiązywania licencji",
		"license_duration_infinite": "Licencja wieczysta",
		"license_already_active": "Aktywny",
		"license_already_active_until": "Subskrybent do dnia {{date}}",
		"vat": "VAT"
	},
	yes: "tak",
	no: "nie",
	next: "Następny",
	back: "Powrót",
	language: "Język",
	preferences: "Preferencje",
	go_back: "Wróć",
	open: "Otwarty",
	close: "Zamknij",
	login: "Logowanie",
	no_video_found: "Nie znaleziono wideo.",
	watch_playlist_on_youtube: "Obejrzyj całą playlistę na YouTube",
	search_video: "Wyszukiwanie wideo",
	logout: "Wylogowanie",
	admin_panel: "Panel administracyjny",
	my_products: "Moje produkty",
	profile: "Profil",
	starting_from: "Począwszy od",
	address: "Adres",
	more_info: "Więcej informacji",
	click_to_expand: "Kliknij, aby rozwinąć",
	skip: "Pomiń",
	signup: "Rejestracja",
	loading: "Ładowanie...",
	cookie_policy: "Polityka plików cookie",
	privacy_policy: "Polityka prywatności",
	warning: "Ostrzeżenie",
	error: "Błąd",
	no_results: "Nie znaleziono żadnych wyników.",
	read_more: "Czytaj więcej",
	recaptcha: "Chronione przez reCAPTCHA",
	captcha: {
		"error_generic": "Nie można zweryfikować captcha. Przeładuj stronę i spróbuj ponownie.",
		"error_threshold": "Wygląda na to, że nie jesteś człowiekiem. Poczekaj kilka minut i spróbuj ponownie."
	},
	feed_not_available: "Kanał niedostępny",
	no_elements_found: "Nie znaleziono żadnych elementów",
	previous_page: "Poprzedni",
	next_page: "Następny",
	docenti: "Nauczyciele",
	yearly: "Rocznie",
	monthly: "Miesięcznie",
	share_on: "Udostępnij na",
	show_more: "Pokaż więcej...",
	show_less: "Pokaż mniej",
	share_with_friend: "Udostępnij znajomemu",
	copy_link: "Kopiuj link",
	copied: "Skopiowany",
	generic_error: "Wystąpił błąd podczas ładowania tego obszaru.",
	elapsed_time: {
		"seconds_one": "1 sekundę temu",
		"seconds_other": "{{count}} sekund temu",
		"minutes_one": "1 minutę temu",
		"minutes_other": "{{count}} minut temu",
		"hours_one": "1 godzinę temu",
		"hours_other": "{{count}} godzin temu",
		"days_one": "1 dzień temu",
		"days_other": "{{count}} dni temu",
		"months_one": "1 miesiąc temu",
		"months_other": "{{count}} miesięcy temu",
		"years_one": "1 rok temu",
		"years_other": "{{count}} lat temu"
	},
	video: {
		"next": "Następny",
		"prev": "Poprzedni",
		"no_videos_found": "Nie znaleziono żadnych filmów",
		"watch_on_yt": "Oglądaj na Youtube",
		"cookie_consent": "Aby obejrzeć ten film, należy zaakceptować pliki cookie",
		"watch_video": "Obejrzyj wideo",
		"muted_notice": "Dźwięk jest wyciszony — kliknij, aby go włączyć",
		"unmute": "Włącz dźwięk"
	},
	reviews: {
		"title": "Recenzje",
		"filterLabels": {
			"province": "Stan",
			"sortBy": "Zamówienie według",
			"rating": "Ocena",
			"course": "Kurs",
			"product": "Produkt",
			"lang": "Język"
		},
		"bad": "Zły",
		"poor": "Słaby",
		"average": "Średnia",
		"great": "Świetnie",
		"excellent": "Doskonały",
		"verified_by_trustpilot": "Na podstawie {{count}} zweryfikowanych recenzji na Trustpilot",
		"read_more": "Czytaj więcej",
		"read_less": "Czytaj mniej",
		"review_date": "Przegląd {{date}}",
		"average_out_of": "{{average}} z {{max}}.",
		"statistics_label_one": "1 gwiazdka",
		"statistics_label_other": "{{count}} gwiazd",
		"empty_set": "Brak recenzji"
	},
	filters: {
		"sort_by": "Sortuj według",
		"filter": "Filtr"
	},
	courses: {
		"next_live": "Na żywo",
		"at_time": "na",
		"promo_label": "{{perc}}% zniżki",
		"free_signup": "Zarejestruj się za darmo",
		"course_signup": "Zapisz się na kurs",
		"free": "Darmowy",
		"buy_for_price": "Kup za {{price}} {{symbol}}",
		"no_course_found": "Nie znaleziono kursu",
		"signin": "Zaloguj się",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 godzina",
		"duration_hours_other": "{{count}} godzin",
		"total_duration": "{{duration}} ogółem",
		"instead_of": "zamiast",
		"promo_expires_on": "Promocja wygasa w dniu {{date}}",
		"lessons": {
			"session_n": "Sesja n. {{sortOrder}}",
			"start_at": "godziny",
			"teachers_one": "Wykładowca: {{names}}",
			"teachers_other": "Wykładowcy: {{names}}",
			"uploaded_at": "Data przesłania: {{date}}",
			"other_content": "Inne treści"
		},
		"course_code": "Kod kursu: {{code}}",
		"live_on": "Na żywo online {{date}}",
		"live_from_to": "Na żywo online od {{from}} do {{to}}",
		"cfp_ack": "Nagrody {{count}} kredyty",
		"cfp_deadline": "CFP deadline {{date}}",
		"reviews_avg": "Średnia recenzji {{average}} na {{total}}.",
		"reviews_count_one": "1 recenzja",
		"reviews_count_other": "{{count}} recenzji",
		"sinf_approval": "Zatwierdzenie SINF",
		"cnappc_approval": "Zatwierdzenie CNAPPC",
		"filter": "Filtry",
		"lessons_count_one": "1 lekcja",
		"lessons_count_other": "{{count}} lekcji",
		"lessons_duration_one": "1 lekcja {{timePerLesson}} + {{timePerTest}} testu",
		"lessons_duration_other": "{{count}} lekcji {{timePerLesson}} + {{timePerTest}} testu",
		"lessons_duration_no_test_one": "1 lekcja {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lekcji {{timePerLesson}}",
		"single_course": "Pojedynczy kurs",
		"add_vat": "+ VAT",
		"vat_included": "W tym podatek VAT",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Nie znaleziono żadnych przedmiotów" },
	pagination: { "next": "Następny" },
	search: {
		"clear": "Wyczyść wyszukiwanie",
		"placeholder": "Wyszukiwanie"
	},
	currency: { "label": "Waluta" },
	alerts: {
		"confirm_consultancy": {
			"title": "Zgłoszenie wysłane",
			"message": "Otrzymaliśmy Twoje zgłoszenie konsultacji. Specjalista wkrótce się z Tobą skontaktuje."
		},
		"consultancy_confirmed": {
			"title": "Konsultacja potwierdzona",
			"message": "Otrzymaliśmy Twoją płatność, a konsultacja została potwierdzona."
		},
		"login_success": {
			"title": "Witamy ponownie",
			"message": "Zalogowano pomyślnie."
		},
		"login_error": {
			"title": "Logowanie nie powiodło się",
			"message": "Coś poszło nie tak. Spróbuj ponownie."
		},
		"logout_success": {
			"title": "Wylogowano",
			"message": "Zostałeś wylogowany."
		}
	}
};
var languages_default$3 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$2 = {
	download: { "wait_download": "<0>Descărcarea ar trebui să înceapă în orice moment. Dacă nu începe automat, <1>click aici</1> pentru a descărca fișierul.</0>." },
	form: {
		"required": "Acest câmp este obligatoriu",
		"minLength": "Introduceți cel puțin {{num}} caractere",
		"maxLength": "Introduceți cel mult {{num}} caractere",
		"pattern": "Valoarea introdusă nu este valabilă",
		"min": "Introduceți o valoare mai mare decât {{num}}",
		"max": "Introduceți o valoare mai mică decât {{num}}",
		"add_file": "Răsfoiește",
		"too_many_files": "Ați selectat prea multe fișiere",
		"too_few_files": "Ați selectat prea puține fișiere",
		"file_too_big": "Fișierul selectat este prea mare",
		"invalid_file": "Fișierul selectat nu este valid",
		"max_files": "Numărul maxim de fișiere",
		"min_files": "Numărul minim de fișiere",
		"types_allowed": "Fișiere permise",
		"max_weight": "Dimensiunea maximă a fișierului",
		"submit_file_is_uploading": "Trebuie să așteptați până la finalizarea încărcării fișierului înainte de a trimite formularul",
		"upload_error": "A apărut o eroare în timpul încărcării fișierului. Vă rugăm să încercați din nou.",
		"submit_validation_error": "A apărut o eroare în timpul trimiterii formularului. Vă rugăm să verificați datele introduse și să încercați din nou.",
		"submit_error": "A apărut o eroare la trimiterea formularului. Vă rugăm să ne contactați dacă problema persistă.",
		"privacy": "Am citit și acceptat <1><0>Politica de confidențialitate</0></1>.",
		"terms": "Am citit și acceptat <1>Termeni și condiții</1>.",
		"login_prefill": "<0>Login</0> pentru a completa automat câmpurile cu datele dumneavoastră.",
		"signup_suggestion": "<0>Înregistrează-te acum</0> pentru a completa automat câmpurile formularului nostru!",
		"captcha_not_resolved": "Pentru a trimite formularul, trebuie să confirmați că sunteți persoană fizică.",
		"captcha_not_ready": "Captcha nu este gata. Reîncărcați pagina și încercați din nou.",
		"invalid_phone_prefix": "Prefix invalid",
		"invalid_email": "Adresă de e-mail invalidă",
		"select": {
			"create": "{userInput}",
			"loading": "Încărcare...",
			"no_options": "Nu s-au găsit opțiuni"
		},
		"invalid_phone": "Numărul de telefon nu este valabil",
		"doesnt_match": "Valorile introduse nu corespund",
		"meeting": {
			"duration": "Durată: {{duration}}",
			"duration_label": "Durată",
			"duration_minutes": "{{minutes}} min",
			"loading": "Se încarcă disponibilitatea…",
			"empty": "Momentan nu există disponibilitate.",
			"no_slots": "Nu există ore disponibile pentru data selectată.",
			"back": "Înapoi la calendar",
			"change": "Schimbă data/ora",
			"timezone": "Fus orar: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Luni",
					"short": "Lun"
				},
				"tuesday": {
					"long": "Marți",
					"short": "Mar"
				},
				"wednesday": {
					"long": "Miercuri",
					"short": "Mie"
				},
				"thursday": {
					"long": "Joi",
					"short": "Joi"
				},
				"friday": {
					"long": "Vineri",
					"short": "Vin"
				},
				"saturday": {
					"long": "Sâmbătă",
					"short": "Sâm"
				},
				"sunday": {
					"long": "Duminică",
					"short": "Dum"
				}
			}
		},
		"slots": {
			"add": "Adaugă disponibilitate",
			"remove": "Elimină",
			"timezone": "Fus orar: {{timezone}}",
			"min": "Indicați cel puțin {{num}} disponibilități.",
			"max": "Puteți indica cel mult {{num}} disponibilități.",
			"item": "Disponibilitate {{number}}"
		}
	},
	pricing: {
		"recommended": "Recomandate",
		"discounted_to": "Ofertă valabilă până la {{date}}",
		"per_month": "lună",
		"per_year": "an",
		"free": "GRATUIT",
		"badge_new": "nou",
		"price_not_available": "Preț temporar indisponibil",
		"btn_buy_now": "Cumpărați",
		"badge_video": "video",
		"incremental_version": "Totul oferit cu {{prevProductName}} și mai mult:",
		"prices_starting_from": "Prețuri de la",
		"per_workstation_zero": "la stație",
		"per_workstation_one": "la stație",
		"per_workstation_other": "pe post (minim {{count}})",
		"license_duration_months_few": "{{count}} luni",
		"license_duration_months_one": "1 lună",
		"license_duration_months_other": "{{count}} luni",
		"license_duration": "Durata licenței",
		"license_duration_infinite": "Licență perpetuă",
		"license_already_active": "Activ",
		"license_already_active_until": "Abonați până la {{date}}",
		"vat": "TVA"
	},
	yes: "da",
	no: "nu",
	next: "Următorul",
	back: "Înapoi",
	language: "Limba",
	preferences: "Preferințe",
	go_back: "Înapoi la începutul paginii",
	open: "Deschis",
	close: "Închidere",
	login: "Conectați-vă",
	no_video_found: "Nu s-au găsit videoclipuri.",
	watch_playlist_on_youtube: "Urmăriți toate videoclipurile pe YouTube",
	search_video: "Căutare video",
	logout: "Ieșire",
	admin_panel: "Panou de administrare",
	my_products: "Produsele mele",
	profile: "Profil",
	starting_from: "Începând de la",
	address: "Adresă",
	more_info: "Mai multe informații",
	click_to_expand: "Faceți clic pentru a extinde",
	skip: "Salt",
	signup: "Înregistrare",
	loading: "Încărcare...",
	cookie_policy: "Politica privind cookie-urile",
	privacy_policy: "Politica de confidențialitate",
	warning: "Atenție",
	error: "Eroare",
	no_results: "Nu s-au găsit rezultate.",
	read_more: "Citește mai mult",
	recaptcha: "Protejat de reCAPTCHA",
	captcha: {
		"error_generic": "Nu se poate verifica captcha. Vă rugăm să reîncărcați pagina și să încercați din nou.",
		"error_threshold": "Se pare că nu sunteți om. Vă rugăm să așteptați câteva minute și să încercați din nou."
	},
	feed_not_available: "Nu există știri disponibile",
	no_elements_found: "Nu s-au găsit articole",
	previous_page: "Articolul precedent",
	next_page: "Următorul",
	docenti: "Profesori",
	yearly: "Anual",
	monthly: "Lunar",
	share_on: "Partajați cu",
	show_more: "Arată mai mult...",
	show_less: "Arată mai puțin",
	share_with_friend: "Partajați cu un prieten",
	copy_link: "Copiere link",
	copied: "Copiat",
	generic_error: "A apărut o eroare în timpul încărcării acestei zone.",
	elapsed_time: {
		"seconds_one": "1 secundă în urmă",
		"seconds_other": "{{count}} acum două secunde",
		"minutes_one": "1 minut în urmă",
		"minutes_other": "{{count}} minute în urmă",
		"hours_one": "1 oră în urmă",
		"hours_other": "{{count}} acum câteva ore",
		"days_one": "1 zi în urmă",
		"days_other": "{{count}} zile în urmă",
		"months_one": "1 lună în urmă",
		"months_other": "{{count}} luni în urmă",
		"years_one": "1 an în urmă",
		"years_other": "{{count}} ani în urmă"
	},
	video: {
		"next": "Următorul",
		"prev": "Articolul precedent",
		"no_videos_found": "Nu s-au găsit videoclipuri",
		"watch_on_yt": "Urmăriți pe YouTube",
		"cookie_consent": "Pentru a viziona acest videoclip trebuie să acceptați cookie-urile",
		"watch_video": "Urmăriți videoclipul",
		"muted_notice": "Sunetul este dezactivat — apasă pentru a-l activa",
		"unmute": "Activează sunetul"
	},
	reviews: {
		"title": "Recenzii",
		"filterLabels": {
			"province": "Provincie",
			"sortBy": "Sortare după",
			"rating": "Vot",
			"course": "Curs",
			"product": "Produs",
			"lang": "Limba"
		},
		"bad": "Rău",
		"poor": "Slabă",
		"average": "Medie",
		"great": "Foarte bun",
		"excellent": "Excelentă",
		"verified_by_trustpilot": "Bazat pe {{count}} recenzii verificate pe Trustpilot",
		"read_more": "Citește mai mult",
		"read_less": "Citește mai puțin",
		"review_date": "Revizuirea {{date}}",
		"average_out_of": "{{average}} pe {{max}}",
		"statistics_label_one": "1 stea",
		"statistics_label_other": "{{count}} stele",
		"empty_set": "Nici o recenzie"
	},
	filters: {
		"sort_by": "Sortare după",
		"filter": "Filtru"
	},
	courses: {
		"next_live": "În direct",
		"at_time": "Ore de lucru",
		"promo_label": "{{perc}}% reducere",
		"free_signup": "Înscrieți-vă gratuit",
		"course_signup": "Înscrieți-vă la curs",
		"free": "Gratuit",
		"buy_for_price": "Cumpărați la {{price}} {{symbol}}",
		"no_course_found": "Nu s-au găsit cursuri",
		"signin": "Accesați cursul",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 oră",
		"duration_hours_other": "{{count}} ore",
		"total_duration": "{{duration}} totaluri",
		"instead_of": "în loc de",
		"promo_expires_on": "Oferta expiră la {{date}}",
		"lessons": {
			"session_n": "Sesiunea nr. {{sortOrder}}",
			"start_at": ", ore",
			"teachers_one": "Profesor: {{names}}",
			"teachers_other": "Profesori: {{names}}",
			"uploaded_at": "Data încărcării: {{date}}",
			"other_content": "Alt conținut"
		},
		"course_code": "Codul cursului: {{code}}",
		"live_on": "Live online pe {{date}}",
		"live_from_to": "Online direct de la {{from}} la {{to}}",
		"cfp_ack": "Recunoaște {{count}} CFP",
		"cfp_deadline": "Termen CFP {{date}}",
		"reviews_avg": "Voturi medii {{average}} pe {{total}}",
		"reviews_count_one": "1 Evaluare",
		"reviews_count_other": "{{count}} ratinguri",
		"sinf_approval": "Aprobarea SINF",
		"cnappc_approval": "Aprobarea CNAPPC",
		"filter": "Filtre",
		"lessons_count_one": "1 lecție",
		"lessons_count_other": "{{count}} lecții",
		"lessons_duration_one": "1 lecție din {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lecții din {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 lecție din {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lecții din {{timePerLesson}}",
		"single_course": "Curs unic",
		"add_vat": "+ TVA",
		"vat_included": "TVA inclus",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Nu s-au găsit articole" },
	pagination: { "next": "Pagina următoare" },
	search: {
		"clear": "Resetați căutarea",
		"placeholder": "Căutare"
	},
	currency: { "label": "Valută" },
	alerts: {
		"confirm_consultancy": {
			"title": "Cerere trimisă",
			"message": "Am primit cererea ta de consultanță. Profesionistul te va contacta în curând."
		},
		"consultancy_confirmed": {
			"title": "Consultație confirmată",
			"message": "Am primit plata ta, iar consultația este confirmată."
		},
		"login_success": {
			"title": "Bine ai revenit",
			"message": "Te-ai autentificat."
		},
		"login_error": {
			"title": "Autentificare eșuată",
			"message": "A apărut o eroare. Vă rugăm să încercați din nou."
		},
		"logout_success": {
			"title": "Deconectare reușită",
			"message": "Te-ai deconectat."
		}
	}
};
var languages_default$2 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default$1 = {
	download: { "wait_download": "<0>Nedladdningen bör starta om några sekunder. Om den inte startar automatiskt, <1>klicka här</1> för att ladda ner filen.</0>" },
	form: {
		"required": "Detta fält är obligatoriskt",
		"minLength": "Skriv minst {{num}} tecken",
		"maxLength": "Max {{num}} tecken är tillåtna",
		"pattern": "Värdet är inte giltigt",
		"min": "Lägsta tillåtna värde: {{num}}",
		"max": "Högsta tillåtna värde: {{num}}",
		"add_file": "Lägg till fil",
		"too_many_files": "För många filer",
		"too_few_files": "För få filer",
		"file_too_big": "Den valda filen är för stor",
		"invalid_file": "Den valda filen är inte giltig",
		"max_files": "Max antal filer",
		"min_files": "Minsta antal filer",
		"types_allowed": "Filer tillåtna",
		"max_weight": "Max filstorlek",
		"submit_file_is_uploading": "Du måste vänta tills uppladdningen är klar innan du skickar in formuläret.",
		"upload_error": "Något gick fel när du laddade upp din fil. Vänligen försök igen.",
		"submit_validation_error": "Något gick fel när du skickade in ditt formulär. Vänligen kontrollera dina uppgifter och försök igen.",
		"submit_error": "Något gick fel när du skickade in ditt formulär. Om problemet kvarstår, vänligen kontakta oss.",
		"privacy": "Jag har läst och godkänt <1><0>Integritetspolicy</0></1>.",
		"terms": "Jag har läst och godkänt <1>villkor och bestämmelser</1>.",
		"login_prefill": "<0>Logga in</0> för att automatiskt fylla i dina uppgifter i formuläret.",
		"signup_suggestion": "<0>Registrera dig nu</0> för att fylla i dina uppgifter i våra formulär!",
		"captcha_not_resolved": "Du måste bekräfta att du är en människa innan du skickar in ditt formulär.",
		"captcha_not_ready": "Captcha är inte redo. Ladda om sidan och försök igen.",
		"invalid_phone_prefix": "Prefixet är inte giltigt",
		"invalid_email": "E-postadressen är inte giltig",
		"select": {
			"create": "{userInput}",
			"loading": "Laddar...",
			"no_options": "Inga alternativ hittades"
		},
		"invalid_phone": "Telefonnumret är ogiltigt",
		"doesnt_match": "De infogade värdena stämmer inte överens",
		"meeting": {
			"duration": "Längd: {{duration}}",
			"duration_label": "Längd",
			"duration_minutes": "{{minutes}} min",
			"loading": "Laddar tillgänglighet…",
			"empty": "Ingen tillgänglighet för tillfället.",
			"no_slots": "Inga tider tillgängliga för det valda datumet.",
			"back": "Tillbaka till kalendern",
			"change": "Ändra datum/tid",
			"timezone": "Tidszon: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Måndag",
					"short": "Mån"
				},
				"tuesday": {
					"long": "Tisdag",
					"short": "Tis"
				},
				"wednesday": {
					"long": "Onsdag",
					"short": "Ons"
				},
				"thursday": {
					"long": "Torsdag",
					"short": "Tor"
				},
				"friday": {
					"long": "Fredag",
					"short": "Fre"
				},
				"saturday": {
					"long": "Lördag",
					"short": "Lör"
				},
				"sunday": {
					"long": "Söndag",
					"short": "Sön"
				}
			}
		},
		"slots": {
			"add": "Lägg till tillgänglighet",
			"remove": "Ta bort",
			"timezone": "Tidszon: {{timezone}}",
			"min": "Ange minst {{num}} tillfällen.",
			"max": "Du kan ange högst {{num}} tillfällen.",
			"item": "Tillgänglighet {{number}}"
		}
	},
	pricing: {
		"recommended": "Rekommenderas",
		"discounted_to": "Kampanjen avslutas {{date}}",
		"per_month": "månad",
		"per_year": "år",
		"free": "GRATIS",
		"badge_new": "ny",
		"price_not_available": "Priset är tillfälligt inte tillgängligt",
		"btn_buy_now": "Köp nu",
		"badge_video": "video",
		"incremental_version": "Allt som erbjuds med {{prevProductName}} och mer:",
		"prices_starting_from": "Priser från och med",
		"per_workstation_zero": "per arbetsstation",
		"per_workstation_one": "per arbetsstation",
		"per_workstation_other": "per arbetsstation (minimum {{count}})",
		"license_duration_months_one": "1 månad",
		"license_duration_months_other": "{{count}} månader",
		"license_duration": "Licensens giltighetstid",
		"license_duration_infinite": "Evig licens",
		"license_already_active": "Aktiv",
		"license_already_active_until": "Prenumerant fram till {{date}}",
		"vat": "MOMS"
	},
	yes: "ja",
	no: "nej",
	next: "Nästa",
	back: "Tillbaka",
	language: "Språk",
	preferences: "Inställningar",
	go_back: "Gå tillbaka",
	open: "Öppna",
	close: "Nära",
	login: "Logga in",
	no_video_found: "Ingen video hittades.",
	watch_playlist_on_youtube: "Se hela spellistan på YouTube",
	search_video: "Sök video",
	logout: "Logga ut",
	admin_panel: "Admin-panel",
	my_products: "Mina produkter",
	profile: "Profil",
	starting_from: "Med utgångspunkt från",
	address: "Adress",
	more_info: "Mer information",
	click_to_expand: "Klicka för att expandera",
	skip: "Hoppa över",
	signup: "Registrera dig",
	loading: "Laddar...",
	cookie_policy: "Policy för cookies",
	privacy_policy: "Integritetspolicy",
	warning: "Varning",
	error: "Fel",
	no_results: "Inga resultat hittades.",
	read_more: "Läs mer på engelska",
	recaptcha: "Skyddas av reCAPTCHA",
	captcha: {
		"error_generic": "Det går inte att verifiera captcha. Vänligen ladda om sidan och försök igen.",
		"error_threshold": "Det verkar som om du inte är en människa. Vänligen vänta några minuter och försök igen."
	},
	feed_not_available: "Foder inte tillgängligt",
	no_elements_found: "Inga element hittades",
	previous_page: "Föregående",
	next_page: "Nästa",
	docenti: "Lärare",
	yearly: "Årligen",
	monthly: "Månadsvis",
	share_on: "Dela på",
	show_more: "Visa mer...",
	show_less: "Visa mindre",
	share_with_friend: "Dela med en vän",
	copy_link: "Kopiera länk",
	copied: "Kopierad",
	generic_error: "Ett fel inträffade när du laddade detta område.",
	elapsed_time: {
		"seconds_one": "1 sekund sedan",
		"seconds_other": "{{count}} sekunder sedan",
		"minutes_one": "1 minut sedan",
		"minutes_other": "{{count}} minuter sedan",
		"hours_one": "1 timme sedan",
		"hours_other": "för {{count}} timmar sedan",
		"days_one": "1 dag sedan",
		"days_other": "{{count}} dagar sedan",
		"months_one": "1 månad sedan",
		"months_other": "{{count}} månader sedan",
		"years_one": "1 år sedan",
		"years_other": "{{count}} år sedan"
	},
	video: {
		"next": "Nästa",
		"prev": "Föregående",
		"no_videos_found": "Inga videor hittades",
		"watch_on_yt": "Titta på Youtube",
		"cookie_consent": "Du måste acceptera cookies för att se den här videon",
		"watch_video": "Titta på video",
		"muted_notice": "Ljudet är avstängt — klicka för att slå på det",
		"unmute": "Slå på ljudet"
	},
	reviews: {
		"title": "Recensioner",
		"filterLabels": {
			"province": "Stat",
			"sortBy": "Beställning av",
			"rating": "Betyg",
			"course": "Kurs",
			"product": "Produkt",
			"lang": "Språk"
		},
		"bad": "Dålig",
		"poor": "Dålig",
		"average": "Genomsnitt",
		"great": "Bra",
		"excellent": "Utmärkt",
		"verified_by_trustpilot": "Baserat på {{count}} verifierade recensioner på Trustpilot",
		"read_more": "Läs mer på engelska",
		"read_less": "Läs mindre",
		"review_date": "Granskning av {{date}}",
		"average_out_of": "{{average}} ut ur {{max}}",
		"statistics_label_one": "1 stjärna",
		"statistics_label_other": "{{count}} stjärnor",
		"empty_set": "Inga recensioner"
	},
	filters: {
		"sort_by": "Sortera efter",
		"filter": "Filter"
	},
	courses: {
		"next_live": "Lev",
		"at_time": "på",
		"promo_label": "{{perc}}% rabatt",
		"free_signup": "Registrera dig gratis",
		"course_signup": "Anmäl dig till kursen",
		"free": "Gratis",
		"buy_for_price": "Köp för {{price}} {{symbol}}",
		"no_course_found": "Ingen kurs hittades",
		"signin": "Registrera dig",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 timme",
		"duration_hours_other": "{{count}} timmar",
		"total_duration": "{{duration}} totalt",
		"instead_of": "istället för",
		"promo_expires_on": "Kampanjen löper ut den {{date}}",
		"lessons": {
			"session_n": "Session n. {{sortOrder}}",
			"start_at": ", timmar",
			"teachers_one": "Lärare: {{names}}",
			"teachers_other": "Lärare: {{names}}",
			"uploaded_at": "Uppladdningsdatum: {{date}}",
			"other_content": "Övrigt innehåll"
		},
		"course_code": "Kursens kod: {{code}}",
		"live_on": "Live online på {{date}}",
		"live_from_to": "Live online från {{from}} till {{to}}",
		"cfp_ack": "Utmärkelser {{count}} krediter",
		"cfp_deadline": "CFP:s deadline {{date}}",
		"reviews_avg": "Recensioner genomsnittlig {{average}} av {{total}}",
		"reviews_count_one": "1 recension",
		"reviews_count_other": "{{count}} recensioner",
		"sinf_approval": "Godkännande av SINF",
		"cnappc_approval": "Godkännande av CNAPPC",
		"filter": "Filter",
		"lessons_count_one": "1 lektion",
		"lessons_count_other": "{{count}} lektioner",
		"lessons_duration_one": "1 lektion av {{timePerLesson}} + {{timePerTest}} prov",
		"lessons_duration_other": "{{count}} lektioner av {{timePerLesson}} + {{timePerTest}} prov",
		"lessons_duration_no_test_one": "1 lektion av {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lektioner av {{timePerLesson}}",
		"single_course": "Enstaka kurs",
		"add_vat": "+ MOMS",
		"vat_included": "Inklusive moms",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Inga objekt hittades" },
	pagination: { "next": "Nästa" },
	search: {
		"clear": "Tydlig sökning",
		"placeholder": "Sök"
	},
	currency: { "label": "Valuta" },
	alerts: {
		"confirm_consultancy": {
			"title": "Förfrågan skickad",
			"message": "Vi har tagit emot din rådgivningsförfrågan. Experten kontaktar dig inom kort."
		},
		"consultancy_confirmed": {
			"title": "Konsultationen är bekräftad",
			"message": "Vi har tagit emot din betalning och konsultationen är bekräftad."
		},
		"login_success": {
			"title": "Välkommen tillbaka",
			"message": "Du är nu inloggad."
		},
		"login_error": {
			"title": "Inloggningen misslyckades",
			"message": "Något gick fel. Vänligen försök igen."
		},
		"logout_success": {
			"title": "Utloggad",
			"message": "Du har loggats ut."
		}
	}
};
var languages_default$1 = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var core_default = {
	download: { "wait_download": "<0>Het downloaden zou binnen een paar seconden moeten beginnen. Als het niet automatisch start, <1>klik hier</1> om het bestand te downloaden.</0>" },
	form: {
		"required": "Dit veld is verplicht",
		"minLength": "Typ ten minste {{num}} tekens",
		"maxLength": "Max {{num}} tekens zijn toegestaan",
		"pattern": "De waarde is ongeldig",
		"min": "Minimaal toegestane waarde: {{num}}",
		"max": "Maximaal toegestane waarde: {{num}}",
		"add_file": "Bestand toevoegen",
		"too_many_files": "Te veel bestanden",
		"too_few_files": "Te weinig bestanden",
		"file_too_big": "Het geselecteerde bestand is te groot",
		"invalid_file": "Het geselecteerde bestand is niet geldig",
		"max_files": "Maximaal aantal bestanden",
		"min_files": "Minimaal aantal bestanden",
		"types_allowed": "Toegestane bestanden",
		"max_weight": "Maximale bestandsgrootte",
		"submit_file_is_uploading": "U moet wachten tot het uploaden is voltooid voordat u uw formulier verzendt.",
		"upload_error": "Er is iets misgegaan tijdens het uploaden van je bestand. Probeer het opnieuw.",
		"submit_validation_error": "Er is iets misgegaan bij het verzenden van uw formulier. Controleer uw gegevens en probeer het opnieuw.",
		"submit_error": "Er is iets misgegaan bij het verzenden van uw formulier. Als het probleem zich blijft voordoen, neem dan contact met ons op.",
		"privacy": "Ik heb het <1><0>Privacybeleid</0></1> gelezen en ga ermee akkoord.",
		"terms": "Ik heb de <1>voorwaarden</1> gelezen en ga ermee akkoord.",
		"login_prefill": "<0>Login</0> om je gegevens automatisch in het formulier in te vullen.",
		"signup_suggestion": "<0>Schrijf je nu in</0> om je gegevens vooraf in te vullen in onze formulieren!",
		"captcha_not_resolved": "U moet bevestigen dat u een mens bent voordat u het formulier verzendt.",
		"captcha_not_ready": "De captcha is niet gereed. Laad de pagina opnieuw en probeer het opnieuw.",
		"invalid_phone_prefix": "Voorvoegsel niet geldig",
		"invalid_email": "E-mailadres ongeldig",
		"select": {
			"create": "{userInput}",
			"loading": "Aan het laden...",
			"no_options": "Geen opties gevonden"
		},
		"invalid_phone": "Het telefoonnummer is ongeldig",
		"doesnt_match": "De ingevoegde waarden komen niet overeen",
		"meeting": {
			"duration": "Duur: {{duration}}",
			"duration_label": "Duur",
			"duration_minutes": "{{minutes}} min",
			"loading": "Beschikbaarheid laden…",
			"empty": "Momenteel geen beschikbaarheid.",
			"no_slots": "Geen tijden beschikbaar voor de geselecteerde datum.",
			"back": "Terug naar de kalender",
			"change": "Datum/tijd wijzigen",
			"timezone": "Tijdzone: {{timezone}}",
			"weekdays": {
				"monday": {
					"long": "Maandag",
					"short": "Ma"
				},
				"tuesday": {
					"long": "Dinsdag",
					"short": "Di"
				},
				"wednesday": {
					"long": "Woensdag",
					"short": "Wo"
				},
				"thursday": {
					"long": "Donderdag",
					"short": "Do"
				},
				"friday": {
					"long": "Vrijdag",
					"short": "Vr"
				},
				"saturday": {
					"long": "Zaterdag",
					"short": "Za"
				},
				"sunday": {
					"long": "Zondag",
					"short": "Zo"
				}
			}
		},
		"slots": {
			"add": "Beschikbaarheid toevoegen",
			"remove": "Verwijderen",
			"timezone": "Tijdzone: {{timezone}}",
			"min": "Geef ten minste {{num}} beschikbaarheden op.",
			"max": "U kunt maximaal {{num}} beschikbaarheden opgeven.",
			"item": "Beschikbaarheid {{number}}"
		}
	},
	pricing: {
		"recommended": "Aanbevolen",
		"discounted_to": "Promotie eindigt {{date}}",
		"per_month": "maand",
		"per_year": "jaar",
		"free": "GRATIS",
		"badge_new": "nieuw",
		"price_not_available": "Prijs tijdelijk niet beschikbaar",
		"btn_buy_now": "Nu kopen",
		"badge_video": "video",
		"incremental_version": "Alles aangeboden met {{prevProductName}} en meer:",
		"prices_starting_from": "Prijzen vanaf",
		"per_workstation_zero": "per werkplek",
		"per_workstation_one": "per werkplek",
		"per_workstation_other": "per werkstation (minimum {{count}})",
		"license_duration_months_one": "1 maand",
		"license_duration_months_other": "{{count}} maanden",
		"license_duration": "Licentie duur",
		"license_duration_infinite": "Eeuwigdurende licentie",
		"license_already_active": "Actief",
		"license_already_active_until": "Abonnement tot {{date}}",
		"vat": "BTW"
	},
	yes: "ja",
	no: "geen",
	next: "Volgende",
	back: "Terug",
	language: "Taal",
	preferences: "Voorkeuren",
	go_back: "Ga terug",
	open: "Open",
	close: "Sluit",
	login: "Inloggen",
	no_video_found: "Geen video gevonden.",
	watch_playlist_on_youtube: "Bekijk de hele afspeellijst op YouTube",
	search_video: "Video zoeken",
	logout: "Afmelden",
	admin_panel: "Beheerderspaneel",
	my_products: "Mijn producten",
	profile: "Profiel",
	starting_from: "Vanaf",
	address: "Adres",
	more_info: "Meer informatie",
	click_to_expand: "Klik om uit te breiden",
	skip: "Skip",
	signup: "Aanmelden",
	loading: "Aan het laden...",
	cookie_policy: "Cookiebeleid",
	privacy_policy: "Privacybeleid",
	warning: "Waarschuwing",
	error: "Fout",
	no_results: "Geen resultaten gevonden.",
	read_more: "Meer lezen",
	recaptcha: "Beschermd door reCAPTCHA",
	captcha: {
		"error_generic": "Kan de captcha niet verifiëren. Laad de pagina opnieuw en probeer het opnieuw.",
		"error_threshold": "Het lijkt erop dat je geen mens bent. Wacht een paar minuten en probeer het opnieuw."
	},
	feed_not_available: "Voer niet beschikbaar",
	no_elements_found: "Geen elementen gevonden",
	previous_page: "Vorige",
	next_page: "Volgende",
	docenti: "Leraren",
	yearly: "Jaarlijks",
	monthly: "Maandelijks",
	share_on: "Deel op",
	show_more: "Toon meer...",
	show_less: "Minder tonen",
	share_with_friend: "Delen met een vriend(in)",
	copy_link: "Link kopiëren",
	copied: "Gekopieerd",
	generic_error: "Er is een fout opgetreden tijdens het laden van dit gebied.",
	elapsed_time: {
		"seconds_one": "1 seconde geleden",
		"seconds_other": "{{count}} seconden geleden",
		"minutes_one": "1 minuut geleden",
		"minutes_other": "{{count}} minuten geleden",
		"hours_one": "1 uur geleden",
		"hours_other": "{{count}} uren geleden",
		"days_one": "1 dag geleden",
		"days_other": "{{count}} dagen geleden",
		"months_one": "1 maand geleden",
		"months_other": "{{count}} maanden geleden",
		"years_one": "1 jaar geleden",
		"years_other": "{{count}} jaren geleden"
	},
	video: {
		"next": "Volgende",
		"prev": "Vorige",
		"no_videos_found": "Geen video's gevonden",
		"watch_on_yt": "Bekijk op Youtube",
		"cookie_consent": "U moet cookies accepteren om deze video te bekijken",
		"watch_video": "Video bekijken",
		"muted_notice": "Het geluid is gedempt — klik om het aan te zetten",
		"unmute": "Geluid aanzetten"
	},
	reviews: {
		"title": "Beoordelingen",
		"filterLabels": {
			"province": "Staat",
			"sortBy": "Bestel door",
			"rating": "Beoordeling",
			"course": "Cursus",
			"product": "Product",
			"lang": "Taal"
		},
		"bad": "Slecht",
		"poor": "Slecht",
		"average": "Gemiddeld",
		"great": "Geweldig",
		"excellent": "Uitstekend",
		"verified_by_trustpilot": "Gebaseerd op {{count}} geverifieerde beoordelingen op Trustpilot",
		"read_more": "Meer lezen",
		"read_less": "Minder lezen",
		"review_date": "Herziening van {{date}}",
		"average_out_of": "{{average}} van {{max}}",
		"statistics_label_one": "1 ster",
		"statistics_label_other": "{{count}} sterren",
		"empty_set": "Geen beoordelingen"
	},
	filters: {
		"sort_by": "Sorteren op",
		"filter": "Filter"
	},
	courses: {
		"next_live": "Live",
		"at_time": "op",
		"promo_label": "{{perc}}% korting",
		"free_signup": "Gratis aanmelden",
		"course_signup": "Inschrijven voor de cursus",
		"free": "Gratis",
		"buy_for_price": "Kopen voor {{price}} {{symbol}}",
		"no_course_found": "Geen cursus gevonden",
		"signin": "Aanmelden",
		"duration_minutes": "{{m}} min",
		"duration_hours_one": "1 uur",
		"duration_hours_other": "{{count}} uren",
		"total_duration": "{{duration}} totaal",
		"instead_of": "in plaats van",
		"promo_expires_on": "Promo vervalt op {{date}}",
		"lessons": {
			"session_n": "Sessie n. {{sortOrder}}",
			"start_at": ", uren",
			"teachers_one": "Docent: {{names}}",
			"teachers_other": "Docenten: {{names}}",
			"uploaded_at": "Uploaddatum: {{date}}",
			"other_content": "Overige inhoud"
		},
		"course_code": "Cursuscode: {{code}}",
		"live_on": "Live online op {{date}}",
		"live_from_to": "Live online van {{from}} tot {{to}}",
		"cfp_ack": "Onderscheidingen {{count}} credits",
		"cfp_deadline": "Uiterste datum CFP {{date}}",
		"reviews_avg": "Recensies gemiddeld {{average}} van {{total}}",
		"reviews_count_one": "1 beoordeling",
		"reviews_count_other": "{{count}} beoordelingen",
		"sinf_approval": "SINF-goedkeuring",
		"cnappc_approval": "CNAPPC-goedkeuring",
		"filter": "Filters",
		"lessons_count_one": "1 les",
		"lessons_count_other": "{{count}} lessen",
		"lessons_duration_one": "1 les van {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_other": "{{count}} lessen van {{timePerLesson}} + {{timePerTest}} test",
		"lessons_duration_no_test_one": "1 les van {{timePerLesson}}",
		"lessons_duration_no_test_other": "{{count}} lessen van {{timePerLesson}}",
		"single_course": "Enkele cursus",
		"add_vat": "+ BTW",
		"vat_included": "incl. btw",
		"card_credits_uploaded": "CFP uploaded on {{date}}",
		"card_credits_pending_with_count": "{{count}} CFP will be uploaded in {{date}}",
		"card_credits_pending_generic": "CFP will be uploaded in {{date}}",
		"card_competence_note": " (with competence {{year}})"
	},
	feed: { "no_items_found": "Geen items gevonden" },
	pagination: { "next": "Volgende" },
	search: {
		"clear": "Duidelijk zoeken",
		"placeholder": "Zoek op"
	},
	currency: { "label": "Valuta" },
	alerts: {
		"confirm_consultancy": {
			"title": "Aanvraag verzonden",
			"message": "We hebben je adviesaanvraag ontvangen. De professional neemt binnenkort contact met je op."
		},
		"consultancy_confirmed": {
			"title": "Consult bevestigd",
			"message": "Je betaling is ontvangen en je consult is bevestigd."
		},
		"login_success": {
			"title": "Welkom terug",
			"message": "Je bent nu ingelogd."
		},
		"login_error": {
			"title": "Inloggen mislukt",
			"message": "Er is iets fout gegaan. Probeer het opnieuw."
		},
		"logout_success": {
			"title": "Afgemeld",
			"message": "Je bent afgemeld."
		}
	}
};
var languages_default = {
	en: "English",
	"en-GB": "English",
	it: "Italiano",
	"it-IT": "Italiano",
	es: "Español",
	"es-ES": "Español",
	fr: "Français",
	"fr-FR": "Français",
	de: "Deutsch",
	"de-DE": "Deutsch",
	pt: "Português",
	"pt-PT": "Português",
	"pt-BR": "Português",
	pl: "Polskie",
	"pl-PL": "Polskie",
	ru: "Русский",
	"ru-RU": "Русский",
	cs: "Čeština",
	"cs-CZ": "Čeština",
	hu: "Magyar",
	"hu-HU": "Magyar",
	sv: "Svenska",
	"sv-SE": "Svenska",
	nl: "Nederlands",
	"nl-NL": "Nederlands",
	ro: "Român",
	"ro-RO": "Român"
};
var error_default$11 = {
	title: "Jejda… něco se pokazilo",
	description: "Problém jsme již zaznamenali. Můžete to zkusit znovu nebo se vrátit domů.",
	retry: "Zkusit znovu",
	home: "Domů"
};
var error_default$10 = {
	title: "Ups… etwas ist schiefgelaufen",
	description: "Wir wurden bereits benachrichtigt. Du kannst es erneut versuchen oder zur Startseite zurückkehren.",
	retry: "Erneut versuchen",
	home: "Startseite"
};
var error_default$9 = {
	title: "Oops… something went wrong",
	description: "We've already been notified. You can try again or go back home.",
	retry: "Retry",
	home: "Home"
};
var error_default$8 = {
	title: "Vaya… algo ha salido mal",
	description: "Ya hemos sido notificados. Puedes intentarlo de nuevo o volver al inicio.",
	retry: "Reintentar",
	home: "Inicio"
};
var error_default$7 = {
	title: "Oups… une erreur est survenue",
	description: "Nous avons déjà été notifiés. Vous pouvez réessayer ou revenir à l'accueil.",
	retry: "Réessayer",
	home: "Accueil"
};
var error_default$6 = {
	title: "Hoppá… valami hiba történt",
	description: "A problémát már jeleztük. Próbáld újra, vagy térj vissza a főoldalra.",
	retry: "Újra",
	home: "Főoldal"
};
var error_default$5 = {
	title: "Ops… qualcosa è andato storto",
	description: "Abbiamo già segnalato il problema. Puoi riprovare o tornare alla home.",
	retry: "Riprova",
	home: "Home"
};
var error_default$4 = {
	title: "Oeps… er is iets misgegaan",
	description: "We zijn al op de hoogte. Je kunt het opnieuw proberen of teruggaan naar home.",
	retry: "Opnieuw proberen",
	home: "Home"
};
var error_default$3 = {
	title: "Ups… coś poszło nie tak",
	description: "Problem został już zgłoszony. Możesz spróbować ponownie lub wrócić na stronę główną.",
	retry: "Spróbuj ponownie",
	home: "Strona główna"
};
var error_default$2 = {
	title: "Ops… algo correu mal",
	description: "Já fomos notificados. Podes tentar novamente ou voltar ao início.",
	retry: "Tentar novamente",
	home: "Início"
};
var error_default$1 = {
	title: "Ups… ceva nu a funcționat",
	description: "Am fost deja notificați. Poți încerca din nou sau poți reveni acasă.",
	retry: "Reîncearcă",
	home: "Acasă"
};
var error_default = {
	title: "Oj… något gick fel",
	description: "Vi har redan blivit notifierade. Du kan försöka igen eller gå tillbaka hem.",
	retry: "Försök igen",
	home: "Hem"
};
//#endregion
//#region ../../../../node_modules/intl-pluralrules/factory.mjs
var factory_exports = /* @__PURE__ */ __exportAll({ default: () => getPluralRules });
function _typeof(obj) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
		return typeof obj;
	} : function(obj) {
		return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	}, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
	}
}
function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	Object.defineProperty(Constructor, "prototype", { writable: false });
	return Constructor;
}
function _toPrimitive(input, hint) {
	if (typeof input !== "object" || input === null) return input;
	var prim = input[Symbol.toPrimitive];
	if (prim !== void 0) {
		var res = prim.call(input, hint || "default");
		if (typeof res !== "object") return res;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
	var key = _toPrimitive(arg, "string");
	return typeof key === "symbol" ? key : String(key);
}
function _classPrivateFieldGet(receiver, privateMap) {
	return _classApplyDescriptorGet(receiver, _classExtractFieldDescriptor(receiver, privateMap, "get"));
}
function _classPrivateFieldSet(receiver, privateMap, value) {
	_classApplyDescriptorSet(receiver, _classExtractFieldDescriptor(receiver, privateMap, "set"), value);
	return value;
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
	if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
	return privateMap.get(receiver);
}
function _classApplyDescriptorGet(receiver, descriptor) {
	if (descriptor.get) return descriptor.get.call(receiver);
	return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
	if (descriptor.set) descriptor.set.call(receiver, value);
	else {
		if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
		descriptor.value = value;
	}
}
function _checkPrivateRedeclaration(obj, privateCollection) {
	if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
	_checkPrivateRedeclaration(obj, privateMap);
	privateMap.set(obj, value);
}
function getType(opt) {
	var type = Object.prototype.hasOwnProperty.call(opt, "type") && opt.type;
	if (!type) return "cardinal";
	if (type === "cardinal" || type === "ordinal") return type;
	throw new RangeError("Not a valid plural type: " + JSON.stringify(type));
}
function toNumber(value) {
	switch (_typeof(value)) {
		case "number": return value;
		case "bigint": throw new TypeError("Cannot convert a BigInt value to a number");
		default: return Number(value);
	}
}
function getPluralRules(NumberFormat, getSelector, getCategories, getRangeSelector) {
	var findLocale = function findLocale(locale) {
		do {
			if (getSelector(locale)) return locale;
			locale = locale.replace(/-?[^-]*$/, "");
		} while (locale);
		return null;
	};
	var resolveLocale = function resolveLocale(locales) {
		var canonicalLocales = canonicalizeLocaleList(locales);
		for (var i = 0; i < canonicalLocales.length; ++i) {
			var _lc = findLocale(canonicalLocales[i]);
			if (_lc) return _lc;
		}
		var lc = new NumberFormat().resolvedOptions().locale;
		return findLocale(lc);
	};
	var _locale = /*#__PURE__*/ new WeakMap();
	var _range = /*#__PURE__*/ new WeakMap();
	var _select = /*#__PURE__*/ new WeakMap();
	var _type = /*#__PURE__*/ new WeakMap();
	var _nf = /*#__PURE__*/ new WeakMap();
	var PluralRules = /*#__PURE__*/ function() {
		function PluralRules() {
			var locales = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
			var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			_classCallCheck(this, PluralRules);
			_classPrivateFieldInitSpec(this, _locale, {
				writable: true,
				value: void 0
			});
			_classPrivateFieldInitSpec(this, _range, {
				writable: true,
				value: void 0
			});
			_classPrivateFieldInitSpec(this, _select, {
				writable: true,
				value: void 0
			});
			_classPrivateFieldInitSpec(this, _type, {
				writable: true,
				value: void 0
			});
			_classPrivateFieldInitSpec(this, _nf, {
				writable: true,
				value: void 0
			});
			_classPrivateFieldSet(this, _locale, resolveLocale(locales));
			_classPrivateFieldSet(this, _select, getSelector(_classPrivateFieldGet(this, _locale)));
			_classPrivateFieldSet(this, _range, getRangeSelector(_classPrivateFieldGet(this, _locale)));
			_classPrivateFieldSet(this, _type, getType(opt));
			_classPrivateFieldSet(this, _nf, new NumberFormat("en", opt));
		}
		_createClass(PluralRules, [
			{
				key: "resolvedOptions",
				value: function resolvedOptions() {
					var _classPrivateFieldGet2 = _classPrivateFieldGet(this, _nf).resolvedOptions(), minimumIntegerDigits = _classPrivateFieldGet2.minimumIntegerDigits, minimumFractionDigits = _classPrivateFieldGet2.minimumFractionDigits, maximumFractionDigits = _classPrivateFieldGet2.maximumFractionDigits, minimumSignificantDigits = _classPrivateFieldGet2.minimumSignificantDigits, maximumSignificantDigits = _classPrivateFieldGet2.maximumSignificantDigits, roundingPriority = _classPrivateFieldGet2.roundingPriority;
					var opt = {
						locale: _classPrivateFieldGet(this, _locale),
						type: _classPrivateFieldGet(this, _type),
						minimumIntegerDigits,
						minimumFractionDigits,
						maximumFractionDigits
					};
					if (typeof minimumSignificantDigits === "number") {
						opt.minimumSignificantDigits = minimumSignificantDigits;
						opt.maximumSignificantDigits = maximumSignificantDigits;
					}
					opt.pluralCategories = getCategories(_classPrivateFieldGet(this, _locale), _classPrivateFieldGet(this, _type) === "ordinal").slice(0);
					opt.roundingPriority = roundingPriority || "auto";
					return opt;
				}
			},
			{
				key: "select",
				value: function select(number) {
					if (!(this instanceof PluralRules)) throw new TypeError("select() called on incompatible ".concat(this));
					if (typeof number !== "number") number = Number(number);
					if (!isFinite(number)) return "other";
					var fmt = _classPrivateFieldGet(this, _nf).format(Math.abs(number));
					return _classPrivateFieldGet(this, _select).call(this, fmt, _classPrivateFieldGet(this, _type) === "ordinal");
				}
			},
			{
				key: "selectRange",
				value: function selectRange(start, end) {
					if (!(this instanceof PluralRules)) throw new TypeError("selectRange() called on incompatible ".concat(this));
					if (start === void 0) throw new TypeError("start is undefined");
					if (end === void 0) throw new TypeError("end is undefined");
					var start_ = toNumber(start);
					var end_ = toNumber(end);
					if (!isFinite(start_)) throw new RangeError("start must be finite");
					if (!isFinite(end_)) throw new RangeError("end must be finite");
					return _classPrivateFieldGet(this, _range).call(this, this.select(start_), this.select(end_));
				}
			}
		], [{
			key: "supportedLocalesOf",
			value: function supportedLocalesOf(locales) {
				return canonicalizeLocaleList(locales).filter(findLocale);
			}
		}]);
		return PluralRules;
	}();
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) Object.defineProperty(PluralRules.prototype, Symbol.toStringTag, {
		value: "Intl.PluralRules",
		writable: false,
		configurable: true
	});
	Object.defineProperty(PluralRules, "prototype", { writable: false });
	return PluralRules;
}
var canonicalizeLocaleList;
var init_factory = __esmMin((() => {
	canonicalizeLocaleList = function canonicalizeLocaleList(locales) {
		if (!locales) return [];
		if (!Array.isArray(locales)) locales = [locales];
		var res = {};
		for (var i = 0; i < locales.length; ++i) {
			var _in$iw$ji$lc;
			var tag = locales[i];
			if (tag && _typeof(tag) === "object") tag = String(tag);
			if (typeof tag !== "string") {
				var msg = "Locales should be strings, ".concat(JSON.stringify(tag), " isn't.");
				throw new TypeError(msg);
			}
			var parts = tag.split("-");
			if (!parts.every(function(subtag) {
				return /[a-z0-9]+/i.test(subtag);
			})) {
				var strTag = JSON.stringify(tag);
				var _msg = "The locale ".concat(strTag, " is not a structurally valid BCP 47 language tag.");
				throw new RangeError(_msg);
			}
			var lc = parts[0].toLowerCase();
			parts[0] = (_in$iw$ji$lc = {
				in: "id",
				iw: "he",
				ji: "yi"
			}[lc]) !== null && _in$iw$ji$lc !== void 0 ? _in$iw$ji$lc : lc;
			res[parts.join("-")] = true;
		}
		return Object.keys(res);
	};
}));
//#endregion
//#region ../../../../node_modules/intl-pluralrules/plural-rules.js
var require_plural_rules = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var getPluralRules = (init_factory(), __toCommonJS(factory_exports));
	function _interopDefaultLegacy(e) {
		return e && typeof e === "object" && "default" in e ? e : { "default": e };
	}
	function _mergeNamespaces(n, m) {
		m.forEach(function(e) {
			e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
				if (k !== "default" && !(k in n)) {
					var d = Object.getOwnPropertyDescriptor(e, k);
					Object.defineProperty(n, k, d.get ? d : {
						enumerable: true,
						get: function() {
							return e[k];
						}
					});
				}
			});
		});
		return Object.freeze(n);
	}
	var getPluralRules__default = /*#__PURE__*/ _interopDefaultLegacy(getPluralRules);
	var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
	function getDefaultExportFromCjs(x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
	}
	var plurals$1 = { exports: {} };
	(function(module, exports) {
		var a = function a(n, ord) {
			if (ord) return "other";
			return n == 1 ? "one" : "other";
		};
		var b = function b(n, ord) {
			if (ord) return "other";
			return n == 0 || n == 1 ? "one" : "other";
		};
		var c = function c(n, ord) {
			if (ord) return "other";
			return n >= 0 && n <= 1 ? "one" : "other";
		};
		var d = function d(n, ord) {
			var v0 = !String(n).split(".")[1];
			if (ord) return "other";
			return n == 1 && v0 ? "one" : "other";
		};
		var e = function e(n, ord) {
			return "other";
		};
		var f = function f(n, ord) {
			if (ord) return "other";
			return n == 1 ? "one" : n == 2 ? "two" : "other";
		};
		(function(root, plurals) {
			Object.defineProperty(plurals, "__esModule", { value: true });
			module.exports = plurals;
		})(commonjsGlobal, {
			af: a,
			ak: b,
			am: c,
			an: a,
			ar: function ar(n, ord) {
				var s = String(n).split("."), n100 = Number(s[0]) == n && s[0].slice(-2);
				if (ord) return "other";
				return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
			},
			ars: function ars(n, ord) {
				var s = String(n).split("."), n100 = Number(s[0]) == n && s[0].slice(-2);
				if (ord) return "other";
				return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
			},
			as: function as(n, ord) {
				if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
				return n >= 0 && n <= 1 ? "one" : "other";
			},
			asa: a,
			ast: d,
			az: function az(n, ord) {
				var i = String(n).split(".")[0], i10 = i.slice(-1), i100 = i.slice(-2), i1000 = i.slice(-3);
				if (ord) return i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8 || i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80 ? "one" : i10 == 3 || i10 == 4 || i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900 ? "few" : i == 0 || i10 == 6 || i100 == 40 || i100 == 60 || i100 == 90 ? "many" : "other";
				return n == 1 ? "one" : "other";
			},
			bal: function bal(n, ord) {
				return n == 1 ? "one" : "other";
			},
			be: function be(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
				if (ord) return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? "few" : "other";
				return n10 == 1 && n100 != 11 ? "one" : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? "few" : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? "many" : "other";
			},
			bem: a,
			bez: a,
			bg: a,
			bho: b,
			bm: e,
			bn: function bn(n, ord) {
				if (ord) return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
				return n >= 0 && n <= 1 ? "one" : "other";
			},
			bo: e,
			br: function br(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), n1000000 = t0 && s[0].slice(-6);
				if (ord) return "other";
				return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? "one" : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? "two" : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? "few" : n != 0 && t0 && n1000000 == 0 ? "many" : "other";
			},
			brx: a,
			bs: function bs(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
			},
			ca: function ca(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return n == 1 || n == 3 ? "one" : n == 2 ? "two" : n == 4 ? "few" : "other";
				return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			ce: a,
			ceb: function ceb(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
				if (ord) return "other";
				return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
			},
			cgg: a,
			chr: a,
			ckb: a,
			cs: function cs(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1];
				if (ord) return "other";
				return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
			},
			cy: function cy(n, ord) {
				if (ord) return n == 0 || n == 7 || n == 8 || n == 9 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n == 3 || n == 4 ? "few" : n == 5 || n == 6 ? "many" : "other";
				return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n == 3 ? "few" : n == 6 ? "many" : "other";
			},
			da: function da(n, ord) {
				var s = String(n).split("."), i = s[0], t0 = Number(s[0]) == n;
				if (ord) return "other";
				return n == 1 || !t0 && (i == 0 || i == 1) ? "one" : "other";
			},
			de: d,
			doi: c,
			dsb: function dsb(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i100 = i.slice(-2), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i100 == 1 || f100 == 1 ? "one" : v0 && i100 == 2 || f100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? "few" : "other";
			},
			dv: a,
			dz: e,
			ee: a,
			el: a,
			en: function en(n, ord) {
				var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
				if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
				return n == 1 && v0 ? "one" : "other";
			},
			eo: a,
			es: function es(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return "other";
				return n == 1 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			et: d,
			eu: a,
			fa: c,
			ff: function ff(n, ord) {
				if (ord) return "other";
				return n >= 0 && n < 2 ? "one" : "other";
			},
			fi: d,
			fil: function fil(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
				if (ord) return n == 1 ? "one" : "other";
				return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
			},
			fo: a,
			fr: function fr(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return n == 1 ? "one" : "other";
				return n >= 0 && n < 2 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			fur: a,
			fy: d,
			ga: function ga(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return n == 1 ? "one" : "other";
				return n == 1 ? "one" : n == 2 ? "two" : t0 && n >= 3 && n <= 6 ? "few" : t0 && n >= 7 && n <= 10 ? "many" : "other";
			},
			gd: function gd(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return n == 1 || n == 11 ? "one" : n == 2 || n == 12 ? "two" : n == 3 || n == 13 ? "few" : "other";
				return n == 1 || n == 11 ? "one" : n == 2 || n == 12 ? "two" : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? "few" : "other";
			},
			gl: d,
			gsw: a,
			gu: function gu(n, ord) {
				if (ord) return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
				return n >= 0 && n <= 1 ? "one" : "other";
			},
			guw: b,
			gv: function gv(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 ? "one" : v0 && i10 == 2 ? "two" : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? "few" : !v0 ? "many" : "other";
			},
			ha: a,
			haw: a,
			he: function he(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1];
				if (ord) return "other";
				return i == 1 && v0 || i == 0 && !v0 ? "one" : i == 2 && v0 ? "two" : "other";
			},
			hi: function hi(n, ord) {
				if (ord) return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
				return n >= 0 && n <= 1 ? "one" : "other";
			},
			hnj: e,
			hr: function hr(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
			},
			hsb: function hsb(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i100 = i.slice(-2), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i100 == 1 || f100 == 1 ? "one" : v0 && i100 == 2 || f100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? "few" : "other";
			},
			hu: function hu(n, ord) {
				if (ord) return n == 1 || n == 5 ? "one" : "other";
				return n == 1 ? "one" : "other";
			},
			hy: function hy(n, ord) {
				if (ord) return n == 1 ? "one" : "other";
				return n >= 0 && n < 2 ? "one" : "other";
			},
			ia: d,
			id: e,
			ig: e,
			ii: e,
			io: d,
			is: function is(n, ord) {
				var s = String(n).split("."), i = s[0], t = (s[1] || "").replace(/0+$/, ""), t0 = Number(s[0]) == n, i10 = i.slice(-1), i100 = i.slice(-2);
				if (ord) return "other";
				return t0 && i10 == 1 && i100 != 11 || t % 10 == 1 && t % 100 != 11 ? "one" : "other";
			},
			it: function it(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
				return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			iu: f,
			ja: e,
			jbo: e,
			jgo: a,
			jmc: a,
			jv: e,
			jw: e,
			ka: function ka(n, ord) {
				var i = String(n).split(".")[0], i100 = i.slice(-2);
				if (ord) return i == 1 ? "one" : i == 0 || i100 >= 2 && i100 <= 20 || i100 == 40 || i100 == 60 || i100 == 80 ? "many" : "other";
				return n == 1 ? "one" : "other";
			},
			kab: function kab(n, ord) {
				if (ord) return "other";
				return n >= 0 && n < 2 ? "one" : "other";
			},
			kaj: a,
			kcg: a,
			kde: e,
			kea: e,
			kk: function kk(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
				if (ord) return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? "many" : "other";
				return n == 1 ? "one" : "other";
			},
			kkj: a,
			kl: a,
			km: e,
			kn: c,
			ko: e,
			ks: a,
			ksb: a,
			ksh: function ksh(n, ord) {
				if (ord) return "other";
				return n == 0 ? "zero" : n == 1 ? "one" : "other";
			},
			ku: a,
			kw: function kw(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2), n1000 = t0 && s[0].slice(-3), n100000 = t0 && s[0].slice(-5), n1000000 = t0 && s[0].slice(-6);
				if (ord) return t0 && n >= 1 && n <= 4 || n100 >= 1 && n100 <= 4 || n100 >= 21 && n100 <= 24 || n100 >= 41 && n100 <= 44 || n100 >= 61 && n100 <= 64 || n100 >= 81 && n100 <= 84 ? "one" : n == 5 || n100 == 5 ? "many" : "other";
				return n == 0 ? "zero" : n == 1 ? "one" : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1e3 && n100000 <= 2e4 || n100000 == 4e4 || n100000 == 6e4 || n100000 == 8e4) || n != 0 && n1000000 == 1e5 ? "two" : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? "few" : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? "many" : "other";
			},
			ky: a,
			lag: function lag(n, ord) {
				var i = String(n).split(".")[0];
				if (ord) return "other";
				return n == 0 ? "zero" : (i == 0 || i == 1) && n != 0 ? "one" : "other";
			},
			lb: a,
			lg: a,
			lij: function lij(n, ord) {
				var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n;
				if (ord) return n == 11 || n == 8 || t0 && n >= 80 && n <= 89 || t0 && n >= 800 && n <= 899 ? "many" : "other";
				return n == 1 && v0 ? "one" : "other";
			},
			lkt: e,
			ln: b,
			lo: function lo(n, ord) {
				if (ord) return n == 1 ? "one" : "other";
				return "other";
			},
			lt: function lt(n, ord) {
				var s = String(n).split("."), f = s[1] || "", t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
				if (ord) return "other";
				return n10 == 1 && (n100 < 11 || n100 > 19) ? "one" : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? "few" : f != 0 ? "many" : "other";
			},
			lv: function lv(n, ord) {
				var s = String(n).split("."), f = s[1] || "", v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
				if (ord) return "other";
				return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? "zero" : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? "one" : "other";
			},
			mas: a,
			mg: b,
			mgo: a,
			mk: function mk(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
				if (ord) return i10 == 1 && i100 != 11 ? "one" : i10 == 2 && i100 != 12 ? "two" : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? "many" : "other";
				return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : "other";
			},
			ml: a,
			mn: a,
			mo: function mo(n, ord) {
				var s = String(n).split("."), v0 = !s[1], n100 = Number(s[0]) == n && s[0].slice(-2);
				if (ord) return n == 1 ? "one" : "other";
				return n == 1 && v0 ? "one" : !v0 || n == 0 || n != 1 && n100 >= 1 && n100 <= 19 ? "few" : "other";
			},
			mr: function mr(n, ord) {
				if (ord) return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : "other";
				return n == 1 ? "one" : "other";
			},
			ms: function ms(n, ord) {
				if (ord) return n == 1 ? "one" : "other";
				return "other";
			},
			mt: function mt(n, ord) {
				var s = String(n).split("."), n100 = Number(s[0]) == n && s[0].slice(-2);
				if (ord) return "other";
				return n == 1 ? "one" : n == 2 ? "two" : n == 0 || n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 19 ? "many" : "other";
			},
			my: e,
			nah: a,
			naq: f,
			nb: a,
			nd: a,
			ne: function ne(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return t0 && n >= 1 && n <= 4 ? "one" : "other";
				return n == 1 ? "one" : "other";
			},
			nl: d,
			nn: a,
			nnh: a,
			no: a,
			nqo: e,
			nr: a,
			nso: b,
			ny: a,
			nyn: a,
			om: a,
			or: function or(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return n == 1 || n == 5 || t0 && n >= 7 && n <= 9 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
				return n == 1 ? "one" : "other";
			},
			os: a,
			osa: e,
			pa: b,
			pap: a,
			pcm: c,
			pl: function pl(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
				if (ord) return "other";
				return n == 1 && v0 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? "many" : "other";
			},
			prg: function prg(n, ord) {
				var s = String(n).split("."), f = s[1] || "", v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
				if (ord) return "other";
				return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? "zero" : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? "one" : "other";
			},
			ps: a,
			pt: function pt(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return "other";
				return i == 0 || i == 1 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			pt_PT: function pt_PT(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return "other";
				return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			rm: a,
			ro: function ro(n, ord) {
				var s = String(n).split("."), v0 = !s[1], n100 = Number(s[0]) == n && s[0].slice(-2);
				if (ord) return n == 1 ? "one" : "other";
				return n == 1 && v0 ? "one" : !v0 || n == 0 || n != 1 && n100 >= 1 && n100 <= 19 ? "few" : "other";
			},
			rof: a,
			ru: function ru(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? "many" : "other";
			},
			rwk: a,
			sah: e,
			saq: a,
			sat: f,
			sc: function sc(n, ord) {
				var v0 = !String(n).split(".")[1];
				if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
				return n == 1 && v0 ? "one" : "other";
			},
			scn: function scn(n, ord) {
				var v0 = !String(n).split(".")[1];
				if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
				return n == 1 && v0 ? "one" : "other";
			},
			sd: a,
			sdh: a,
			se: f,
			seh: a,
			ses: e,
			sg: e,
			sh: function sh(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
			},
			shi: function shi(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return "other";
				return n >= 0 && n <= 1 ? "one" : t0 && n >= 2 && n <= 10 ? "few" : "other";
			},
			si: function si(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "";
				if (ord) return "other";
				return n == 0 || n == 1 || i == 0 && f == 1 ? "one" : "other";
			},
			sk: function sk(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1];
				if (ord) return "other";
				return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
			},
			sl: function sl(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i100 = i.slice(-2);
				if (ord) return "other";
				return v0 && i100 == 1 ? "one" : v0 && i100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || !v0 ? "few" : "other";
			},
			sma: f,
			smi: f,
			smj: f,
			smn: f,
			sms: f,
			sn: a,
			so: a,
			sq: function sq(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
				if (ord) return n == 1 ? "one" : n10 == 4 && n100 != 14 ? "many" : "other";
				return n == 1 ? "one" : "other";
			},
			sr: function sr(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
				if (ord) return "other";
				return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
			},
			ss: a,
			ssy: a,
			st: a,
			su: e,
			sv: function sv(n, ord) {
				var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
				if (ord) return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? "one" : "other";
				return n == 1 && v0 ? "one" : "other";
			},
			sw: d,
			syr: a,
			ta: a,
			te: a,
			teo: a,
			th: e,
			ti: b,
			tig: a,
			tk: function tk(n, ord) {
				var s = String(n).split("."), n10 = Number(s[0]) == n && s[0].slice(-1);
				if (ord) return n10 == 6 || n10 == 9 || n == 10 ? "few" : "other";
				return n == 1 ? "one" : "other";
			},
			tl: function tl(n, ord) {
				var s = String(n).split("."), i = s[0], f = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
				if (ord) return n == 1 ? "one" : "other";
				return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
			},
			tn: a,
			to: e,
			tpi: e,
			tr: a,
			ts: a,
			tzm: function tzm(n, ord) {
				var s = String(n).split("."), t0 = Number(s[0]) == n;
				if (ord) return "other";
				return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? "one" : "other";
			},
			ug: a,
			uk: function uk(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1), i100 = i.slice(-2);
				if (ord) return n10 == 3 && n100 != 13 ? "few" : "other";
				return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? "many" : "other";
			},
			und: e,
			ur: d,
			uz: a,
			ve: a,
			vec: function vec(n, ord) {
				var s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
				if (ord) return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
				return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
			},
			vi: function vi(n, ord) {
				if (ord) return n == 1 ? "one" : "other";
				return "other";
			},
			vo: a,
			vun: a,
			wa: b,
			wae: a,
			wo: e,
			xh: a,
			xog: a,
			yi: d,
			yo: e,
			yue: e,
			zh: e,
			zu: c
		});
	})(plurals$1);
	var plurals = /*@__PURE__*/ getDefaultExportFromCjs(plurals$1.exports);
	var P = /*#__PURE__*/ _mergeNamespaces({
		__proto__: null,
		"default": plurals
	}, [plurals$1.exports]);
	var pluralCategories$1 = { exports: {} };
	(function(module, exports) {
		var z = "zero", o = "one", t = "two", f = "few", m = "many", x = "other";
		var a = {
			cardinal: [o, x],
			ordinal: [x]
		};
		var b = {
			cardinal: [o, x],
			ordinal: [o, x]
		};
		var c = {
			cardinal: [x],
			ordinal: [x]
		};
		var d = {
			cardinal: [
				o,
				t,
				x
			],
			ordinal: [x]
		};
		(function(root, pluralCategories) {
			Object.defineProperty(pluralCategories, "__esModule", { value: true });
			module.exports = pluralCategories;
		})(commonjsGlobal, {
			af: a,
			ak: a,
			am: a,
			an: a,
			ar: {
				cardinal: [
					z,
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			ars: {
				cardinal: [
					z,
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			as: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					m,
					x
				]
			},
			asa: a,
			ast: a,
			az: {
				cardinal: [o, x],
				ordinal: [
					o,
					f,
					m,
					x
				]
			},
			bal: b,
			be: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [f, x]
			},
			bem: a,
			bez: a,
			bg: a,
			bho: a,
			bm: c,
			bn: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					m,
					x
				]
			},
			bo: c,
			br: {
				cardinal: [
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			brx: a,
			bs: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [x]
			},
			ca: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [
					o,
					t,
					f,
					x
				]
			},
			ce: a,
			ceb: a,
			cgg: a,
			chr: a,
			ckb: a,
			cs: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			cy: {
				cardinal: [
					z,
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [
					z,
					o,
					t,
					f,
					m,
					x
				]
			},
			da: a,
			de: a,
			doi: a,
			dsb: {
				cardinal: [
					o,
					t,
					f,
					x
				],
				ordinal: [x]
			},
			dv: a,
			dz: c,
			ee: a,
			el: a,
			en: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					x
				]
			},
			eo: a,
			es: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [x]
			},
			et: a,
			eu: a,
			fa: a,
			ff: a,
			fi: a,
			fil: b,
			fo: a,
			fr: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [o, x]
			},
			fur: a,
			fy: a,
			ga: {
				cardinal: [
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [o, x]
			},
			gd: {
				cardinal: [
					o,
					t,
					f,
					x
				],
				ordinal: [
					o,
					t,
					f,
					x
				]
			},
			gl: a,
			gsw: a,
			gu: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					m,
					x
				]
			},
			guw: a,
			gv: {
				cardinal: [
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			ha: a,
			haw: a,
			he: d,
			hi: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					m,
					x
				]
			},
			hnj: c,
			hr: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [x]
			},
			hsb: {
				cardinal: [
					o,
					t,
					f,
					x
				],
				ordinal: [x]
			},
			hu: b,
			hy: b,
			ia: a,
			id: c,
			ig: c,
			ii: c,
			io: a,
			is: a,
			it: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [m, x]
			},
			iu: d,
			ja: c,
			jbo: c,
			jgo: a,
			jmc: a,
			jv: c,
			jw: c,
			ka: {
				cardinal: [o, x],
				ordinal: [
					o,
					m,
					x
				]
			},
			kab: a,
			kaj: a,
			kcg: a,
			kde: c,
			kea: c,
			kk: {
				cardinal: [o, x],
				ordinal: [m, x]
			},
			kkj: a,
			kl: a,
			km: c,
			kn: a,
			ko: c,
			ks: a,
			ksb: a,
			ksh: {
				cardinal: [
					z,
					o,
					x
				],
				ordinal: [x]
			},
			ku: a,
			kw: {
				cardinal: [
					z,
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [
					o,
					m,
					x
				]
			},
			ky: a,
			lag: {
				cardinal: [
					z,
					o,
					x
				],
				ordinal: [x]
			},
			lb: a,
			lg: a,
			lij: {
				cardinal: [o, x],
				ordinal: [m, x]
			},
			lkt: c,
			ln: a,
			lo: {
				cardinal: [x],
				ordinal: [o, x]
			},
			lt: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			lv: {
				cardinal: [
					z,
					o,
					x
				],
				ordinal: [x]
			},
			mas: a,
			mg: a,
			mgo: a,
			mk: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					m,
					x
				]
			},
			ml: a,
			mn: a,
			mo: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [o, x]
			},
			mr: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					x
				]
			},
			ms: {
				cardinal: [x],
				ordinal: [o, x]
			},
			mt: {
				cardinal: [
					o,
					t,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			my: c,
			nah: a,
			naq: d,
			nb: a,
			nd: a,
			ne: b,
			nl: a,
			nn: a,
			nnh: a,
			no: a,
			nqo: c,
			nr: a,
			nso: a,
			ny: a,
			nyn: a,
			om: a,
			or: {
				cardinal: [o, x],
				ordinal: [
					o,
					t,
					f,
					m,
					x
				]
			},
			os: a,
			osa: c,
			pa: a,
			pap: a,
			pcm: a,
			pl: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			prg: {
				cardinal: [
					z,
					o,
					x
				],
				ordinal: [x]
			},
			ps: a,
			pt: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [x]
			},
			pt_PT: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [x]
			},
			rm: a,
			ro: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [o, x]
			},
			rof: a,
			ru: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			rwk: a,
			sah: c,
			saq: a,
			sat: d,
			sc: {
				cardinal: [o, x],
				ordinal: [m, x]
			},
			scn: {
				cardinal: [o, x],
				ordinal: [m, x]
			},
			sd: a,
			sdh: a,
			se: d,
			seh: a,
			ses: c,
			sg: c,
			sh: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [x]
			},
			shi: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [x]
			},
			si: a,
			sk: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [x]
			},
			sl: {
				cardinal: [
					o,
					t,
					f,
					x
				],
				ordinal: [x]
			},
			sma: d,
			smi: d,
			smj: d,
			smn: d,
			sms: d,
			sn: a,
			so: a,
			sq: {
				cardinal: [o, x],
				ordinal: [
					o,
					m,
					x
				]
			},
			sr: {
				cardinal: [
					o,
					f,
					x
				],
				ordinal: [x]
			},
			ss: a,
			ssy: a,
			st: a,
			su: c,
			sv: b,
			sw: a,
			syr: a,
			ta: a,
			te: a,
			teo: a,
			th: c,
			ti: a,
			tig: a,
			tk: {
				cardinal: [o, x],
				ordinal: [f, x]
			},
			tl: b,
			tn: a,
			to: c,
			tpi: c,
			tr: a,
			ts: a,
			tzm: a,
			ug: a,
			uk: {
				cardinal: [
					o,
					f,
					m,
					x
				],
				ordinal: [f, x]
			},
			und: c,
			ur: a,
			uz: a,
			ve: a,
			vec: {
				cardinal: [
					o,
					m,
					x
				],
				ordinal: [m, x]
			},
			vi: {
				cardinal: [x],
				ordinal: [o, x]
			},
			vo: a,
			vun: a,
			wa: a,
			wae: a,
			wo: c,
			xh: a,
			xog: a,
			yi: a,
			yo: c,
			yue: c,
			zh: c,
			zu: a
		});
	})(pluralCategories$1);
	var pluralCategories = /*@__PURE__*/ getDefaultExportFromCjs(pluralCategories$1.exports);
	var C = /*#__PURE__*/ _mergeNamespaces({
		__proto__: null,
		"default": pluralCategories
	}, [pluralCategories$1.exports]);
	var ranges$1 = { exports: {} };
	(function(module, exports) {
		var a = function a(start, end) {
			return "other";
		};
		var b = function b(start, end) {
			return start === "other" && end === "one" ? "one" : "other";
		};
		var c = function c(start, end) {
			return end || "other";
		};
		(function(root, pluralRanges) {
			Object.defineProperty(pluralRanges, "__esModule", { value: true });
			module.exports = pluralRanges;
		})(commonjsGlobal, {
			af: a,
			ak: b,
			am: c,
			an: a,
			ar: function ar(start, end) {
				return end === "few" ? "few" : end === "many" ? "many" : start === "zero" && end === "one" ? "zero" : start === "zero" && end === "two" ? "zero" : "other";
			},
			as: c,
			az: c,
			be: c,
			bg: a,
			bn: c,
			bs: c,
			ca: a,
			cs: c,
			cy: c,
			da: c,
			de: c,
			el: c,
			en: a,
			es: a,
			et: a,
			eu: a,
			fa: b,
			fi: a,
			fil: c,
			fr: c,
			ga: c,
			gl: c,
			gsw: c,
			gu: c,
			he: a,
			hi: c,
			hr: c,
			hu: c,
			hy: c,
			ia: a,
			id: a,
			io: a,
			is: c,
			it: c,
			ja: a,
			ka: function ka(start, end) {
				return start || "other";
			},
			kk: c,
			km: a,
			kn: c,
			ko: a,
			ky: c,
			lij: c,
			lo: a,
			lt: c,
			lv: function lv(start, end) {
				return end === "one" ? "one" : "other";
			},
			mk: a,
			ml: c,
			mn: c,
			mr: c,
			ms: a,
			my: a,
			nb: a,
			ne: c,
			nl: c,
			no: a,
			or: b,
			pa: c,
			pcm: a,
			pl: c,
			ps: c,
			pt: c,
			ro: function ro(start, end) {
				return end === "few" ? "few" : end === "one" ? "few" : "other";
			},
			ru: c,
			sc: c,
			scn: c,
			sd: b,
			si: function si(start, end) {
				return start === "one" && end === "one" ? "one" : "other";
			},
			sk: c,
			sl: function sl(start, end) {
				return end === "few" ? "few" : end === "one" ? "few" : end === "two" ? "two" : "other";
			},
			sq: c,
			sr: c,
			sv: a,
			sw: c,
			ta: c,
			te: c,
			th: a,
			tk: c,
			tr: c,
			ug: c,
			uk: c,
			ur: a,
			uz: c,
			vi: a,
			yue: a,
			zh: a,
			zu: c
		});
	})(ranges$1);
	var ranges = /*@__PURE__*/ getDefaultExportFromCjs(ranges$1.exports);
	var R = /*#__PURE__*/ _mergeNamespaces({
		__proto__: null,
		"default": ranges
	}, [ranges$1.exports]);
	var Plurals = plurals || P;
	var Categories = pluralCategories || C;
	var RangePlurals = ranges || R;
	var id = function id(lc) {
		return lc === "pt-PT" ? "pt_PT" : lc;
	};
	module.exports = getPluralRules__default["default"](Intl.NumberFormat, function getSelector(lc) {
		return Plurals[id(lc)];
	}, function getCategories(lc, ord) {
		return Categories[id(lc)][ord ? "ordinal" : "cardinal"];
	}, function getRangeSelector(lc) {
		return RangePlurals[id(lc)];
	});
}));
(/* @__PURE__ */ __commonJSMin(((exports, module, this$1) => {
	var PluralRules = require_plural_rules();
	function _interopDefaultLegacy(e) {
		return e && typeof e === "object" && "default" in e ? e : { "default": e };
	}
	var PluralRules__default = /*#__PURE__*/ _interopDefaultLegacy(PluralRules);
	if (typeof Intl === "undefined") {
		if (typeof global !== "undefined") global.Intl = { PluralRules: PluralRules__default["default"] };
		else if (typeof window !== "undefined") window.Intl = { PluralRules: PluralRules__default["default"] };
		else this$1.Intl = { PluralRules: PluralRules__default["default"] };
		PluralRules__default["default"].polyfill = true;
	} else if (!Intl.PluralRules || !Intl.PluralRules.prototype.selectRange) {
		Intl.PluralRules = PluralRules__default["default"];
		PluralRules__default["default"].polyfill = true;
	} else {
		var test = [
			"en",
			"es",
			"ru",
			"zh"
		];
		if (Intl.PluralRules.supportedLocalesOf(test).length < test.length) {
			Intl.PluralRules = PluralRules__default["default"];
			PluralRules__default["default"].polyfill = true;
		}
	}
})))();
var trans = (i18nKey, count) => ({
	i18nKey,
	options: { count }
});
var max = (count) => Math.floor(count);
var i18nTimeAgo = (date) => {
	const elapsedSeconds = (Date.now() - new Date(date).getTime()) / 1e3;
	if (elapsedSeconds < 60) return trans("elapsed_time.seconds", max(elapsedSeconds));
	const elapsedMinutes = elapsedSeconds / 60;
	if (elapsedMinutes < 60) return trans("elapsed_time.minutes", max(elapsedMinutes));
	const elapsedHours = elapsedMinutes / 60;
	if (elapsedHours < 24) return trans("elapsed_time.hours", max(elapsedHours));
	const elapsedDays = elapsedHours / 24;
	if (elapsedDays < 30) return trans("elapsed_time.days", max(elapsedDays));
	const elapsedMonths = elapsedDays / 30;
	if (elapsedMonths < 12) return trans("elapsed_time.months", max(elapsedMonths));
	return trans("elapsed_time.years", max(elapsedDays / 365));
};
//#endregion
//#region src/use-formatted-time-ago.ts
function useFormattedTimeAgo(date) {
	const { t } = useTranslation("core");
	return useMemo(() => {
		const { i18nKey, options } = date ? i18nTimeAgo(date) : { i18nKey: "" };
		return t(i18nKey, options);
	}, [date, t]);
}
//#endregion
//#region src/error-locale.ts
/**
* Synchronous locale resolution for provider-free surfaces.
*
* The top-level `ErrorFallback` sits above the Router and I18n providers by
* design, so it cannot use `usePage()` or `useTranslation()`. This helper
* resolves the page locale from the Blade-injected page props
* (`window.inertiaPage`) with a `document.documentElement.lang` fallback,
* without touching any provider.
*
* Resolution order: `window.inertiaPage.locale` → `fallbackLocale` →
* `document.documentElement.lang` → `'en'`. Region tags are normalized to
* their base (`de-CH` → `de`). The function never throws and is SSR-safe
* (`typeof window` guard, returns `'en'` when `window` is undefined).
*/
function normalizeErrorLocaleTag(tag) {
	if (typeof tag !== "string") return;
	const base = tag.split("-")[0]?.split("_")[0]?.trim().toLowerCase();
	if (!base) return;
	return base;
}
function resolveErrorLocale() {
	if (typeof window !== "undefined") {
		try {
			const page = window.inertiaPage;
			for (const candidate of [page?.locale, page?.fallbackLocale]) {
				const normalized = normalizeErrorLocaleTag(candidate);
				if (normalized) return normalized;
			}
		} catch {}
		try {
			if (typeof document !== "undefined") {
				const normalized = normalizeErrorLocaleTag(document.documentElement.lang);
				if (normalized) return normalized;
			}
		} catch {}
	}
	return "en";
}
//#endregion
//#region src/index.tsx
var DEFAULT_RESOURCES = {
	cs: {
		core: core_default$11,
		languages: languages_default$11,
		error: error_default$11
	},
	de: {
		core: core_default$10,
		languages: languages_default$10,
		error: error_default$10
	},
	en: {
		core: core_default$9,
		languages: languages_default$9,
		error: error_default$9
	},
	es: {
		core: core_default$8,
		languages: languages_default$8,
		error: error_default$8
	},
	fr: {
		core: core_default$7,
		languages: languages_default$7,
		error: error_default$7
	},
	hu: {
		core: core_default$6,
		languages: languages_default$6,
		error: error_default$6
	},
	it: {
		core: core_default$5,
		languages: languages_default$5,
		error: error_default$5
	},
	pt: {
		core: core_default$4,
		languages: languages_default$4,
		error: error_default$2
	},
	ro: {
		core: core_default$2,
		languages: languages_default$2,
		error: error_default$1
	},
	sv: {
		core: core_default$1,
		languages: languages_default$1,
		error: error_default
	},
	nl: {
		core: core_default,
		languages: languages_default,
		error: error_default$4
	},
	pl: {
		core: core_default$3,
		languages: languages_default$3,
		error: error_default$3
	}
};
var EN_ERROR_STRINGS = error_default$9;
var ERROR_STRINGS = {
	cs: error_default$11,
	de: error_default$10,
	en: EN_ERROR_STRINGS,
	es: error_default$8,
	fr: error_default$7,
	hu: error_default$6,
	it: error_default$5,
	nl: error_default$4,
	pl: error_default$3,
	pt: error_default$2,
	ro: error_default$1,
	sv: error_default
};
function getErrorStrings(locale) {
	return ERROR_STRINGS[locale] ?? EN_ERROR_STRINGS;
}
var { ContextProvider, useStore } = createState("I18n", (set) => ({
	resources: DEFAULT_RESOURCES,
	registerResources: (resources) => {
		set((state) => {
			return {
				...state,
				resources: merge(state.resources, resources)
			};
		});
	},
	i18nInstance: null,
	setI18nInstance: (newI18n) => {
		set((state) => ({
			...state,
			i18nInstance: newI18n
		}));
	}
}), (state, props) => ({
	...state,
	...props,
	resources: props.resources ? merge(state.resources, props.resources) : state.resources
}));
var initializeI18n = async (resources, locale, fallbackLocale) => {
	return await createInstance().use(initReactI18next).init({
		resources,
		lng: locale,
		fallbackLng: fallbackLocale,
		interpolation: { escapeValue: false }
	});
};
function InnerElement({ children, loadingElement }) {
	const { locale, fallbackLocale } = usePage();
	const logger = useLogger();
	const resources = useStore((s) => s.resources);
	const i18nInstance = useStore((s) => s.i18nInstance);
	const setI18nInstance = useStore((s) => s.setI18nInstance);
	useEffect(() => {
		if (!i18nInstance) initializeI18n(resources, locale, fallbackLocale).then((newInstance) => {
			setI18nInstance(newInstance);
		}).catch((e) => {
			logger.error(e);
			setI18nInstance(null);
		});
	}, [
		fallbackLocale,
		i18nInstance,
		locale,
		logger,
		resources,
		setI18nInstance
	]);
	if (!i18nInstance) return loadingElement;
	return children;
}
function I18nProvider({ children, loadingElement, ...props }) {
	return /* @__PURE__ */ jsx(ContextProvider, {
		...props,
		children: /* @__PURE__ */ jsx(InnerElement, {
			loadingElement,
			children
		})
	});
}
var useRegisterI18nResources = () => {
	return useStore((state) => state.registerResources);
};
//#endregion
export { DEFAULT_RESOURCES, ERROR_STRINGS, I18nProvider, getErrorStrings, i18nTimeAgo, initializeI18n, normalizeErrorLocaleTag, resolveErrorLocale, useFormattedTimeAgo, useRegisterI18nResources };
